import { PendoCheckbox, PendoIcon, PendoLoadingIndicator, PendoAlert, PendoCheckboxOption, PendoMultiselect, PendoTable, PendoButton, PendoFilterBar, PendoInput, PendoTag, PendoTooltip, PendoAffix, PendoNotification, PendoDrawer, PendoDrawerClose, PendoModal, PendoForm, PendoFormItem, PendoToggle, PendoRadio, PendoRadioGroup, PendoCard, PendoCardSection } from '@pendo/components';
import cloneDeep from 'lodash/cloneDeep.js';
import isEmpty from 'lodash/isEmpty.js';
import { http, initializeHttpWrapper as initializeHttpWrapper$1 } from '@pendo/http';
import get from 'lodash/get.js';
import isUndefined from 'lodash/isUndefined.js';
import uniq from 'lodash/uniq.js';
import values from 'lodash/values.js';
import moment$1 from 'moment-timezone';
import keyBy from 'lodash/keyBy.js';
import isEqual from 'lodash/isEqual.js';
import pick from 'lodash/pick.js';

//
var script$e = {
  name: 'AppRolesList',
  components: {
    PendoCheckbox,
    PendoIcon
  },
  props: {
    apps: {
      type: Array,
      required: true
    },
    disableInteraction: {
      type: Boolean,
      default: false
    },
    indeterminateRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      colorMap: {}
    };
  },
  created() {
    this.setIconBackgroundColors();
  },
  methods: {
    getIconBackgroundColor(index) {
      const colors = ['#A3FFFF', '#FFD9DB', '#C7EDDB', '#DAC5F8', '#FAE4B8', '#BDDDFF', '#FFD8B1'];
      return colors[index % colors.length];
    },
    setIconBackgroundColors() {
      this.apps.forEach((item, index) => {
        this.colorMap[item.id] = this.getIconBackgroundColor(index);
      });
    },
    handleChange(application) {
      this.$emit('change', {
        application
      });
    },
    getAppIconType(platform) {
      switch (platform) {
        case 'web':
          return 'monitor';
        case 'extension':
          return 'puzzle-piece';
        case 'subscription':
          return 'layers';
        default:
          return platform;
      }
    },
    getRoleNamesList(namesString) {
      return namesString.split(', ');
    },
    isIndeterminateRole(name) {
      const roleIndex = this.indeterminateRoles.findIndex(role => {
        return role.name === name;
      });
      return roleIndex >= 0;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "scrollable-list",
    class: {
      interactive: !_vm.disableInteraction
    },
    attrs: {
      "data-cy": "app-roles-list"
    }
  }, _vm._l(_vm.apps, function (app, index) {
    return _c('pendo-checkbox', {
      key: app.id,
      staticClass: "list-item",
      attrs: {
        "id": app.id,
        "value": app.checked,
        "disabled": _vm.disableInteraction
      },
      on: {
        "change": function ($event) {
          return _vm.handleChange(app);
        }
      }
    }, [_c('span', {
      staticClass: "list-item__icon",
      attrs: {
        "data-cy": "app-roles-list-row-" + index + "-icon"
      }
    }, [_c('pendo-icon', {
      attrs: {
        "type": _vm.getAppIconType(app.platform),
        "size": "16",
        "fill": app.platform === 'extension' ? 'currentColor' : 'none'
      }
    }), _vm._v(" "), _c('svg', {
      attrs: {
        "width": "31",
        "height": "29",
        "viewBox": "0 0 31 29",
        "fill": "none"
      }
    }, [_c('path', {
      attrs: {
        "opacity": "0.5",
        "d": "M3.33375 3.89276C4.49055 2.72006 6.08854 1.837 7.5937 1.2194C9.09886 0.601791 10.3907 0.34868 11.245 0.191217C15.7078 -0.220103 17.3906 0.154932 19.3592 0.191217C23.0106 0.602471 22.7607 0.796432 25.6478 2.6589C28.7258 4.64456 30.5735 7.74134 30.9107 11.5016C31.0842 13.4357 31.0124 15.5658 30.629 17.4538C30.2221 19.4571 30.3036 21.4563 29.2541 23.269C28.1092 25.2463 27.1653 26.664 25.0392 27.7017C22.4185 28.9809 19.3021 29.0521 16.4742 28.9813C11.0849 28.8464 6.07614 26.3305 2.92804 21.898C0.441635 18.3972 -0.63659 14.8388 0.381082 10.5648C0.921935 8.29327 1.61324 5.63693 3.33375 3.89276Z",
        "fill": _vm.colorMap[app.id]
      }
    })])], 1), _vm._v(" "), _c('dl', {
      attrs: {
        "data-cy": "app-roles-list-row-" + index
      }
    }, [_c('dt', {
      attrs: {
        "title": app.displayName
      }
    }, [_vm._v("\n                " + _vm._s(app.displayName) + "\n            ")]), _vm._v(" "), _c('dd', _vm._l(_vm.getRoleNamesList(app.roleNames), function (name, roleIndex) {
      return _c('span', {
        key: name,
        class: {
          'indeterminate-role': _vm.isIndeterminateRole(name) && app.checked
        },
        attrs: {
          "data-cy": "app-roles-list-" + roleIndex
        }
      }, [_vm._v("\n                    " + _vm._s(name)), roleIndex !== _vm.getRoleNamesList(app.roleNames).length - 1 ? _c('span', {
        staticClass: "no-background-color"
      }, [_vm._v(",\n                    ")]) : _vm._e()]);
    }), 0)])]);
  }), 1);
};
var __vue_staticRenderFns__$e = [];

/* style */
const __vue_inject_styles__$e = function (inject) {
  if (!inject) return;
  inject("data-v-7ff8f784_0", {
    source: ".scrollable-list[data-v-7ff8f784]{overflow-y:auto;height:calc(100vh - 300px)}.scrollable-list.interactive[data-v-7ff8f784]{overflow-y:auto;height:430px}.indeterminate-role[data-v-7ff8f784]{background-color:#fdefd5}.no-background-color[data-v-7ff8f784]{background-color:#fff}[data-v-7ff8f784] .is-disabled .pendo-checkbox__input{display:none}[data-v-7ff8f784] .pendo-checkbox__label{padding:0;display:flex;align-items:center;min-width:0}[data-v-7ff8f784] .pendo-checkbox__inner{margin:16px}[data-v-7ff8f784] .pendo-checkbox{align-items:center}.interactive .list-item[data-v-7ff8f784]{cursor:pointer;border-radius:3px}.interactive .list-item__icon[data-v-7ff8f784]{border-left:1px solid #dadce5}.list-item[data-v-7ff8f784]{cursor:default;width:100%;padding-right:16px;margin:0 0 8px;border:1px solid #dadce5;border-radius:0}.list-item__icon[data-v-7ff8f784]{padding:0 12px;display:flex;position:relative}.list-item__icon i[data-v-7ff8f784]{position:absolute;top:7px;left:20px}dl[data-v-7ff8f784]{margin:12px 0;min-height:36px;min-width:0}dl dt[data-v-7ff8f784]{color:#2a2c35;font-size:14px;font-weight:600;line-height:19.6px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}dl dd[data-v-7ff8f784]{color:#6a6c75;font-size:12px;font-weight:400;line-height:14.4px;margin-inline-start:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$e = "data-v-7ff8f784";
/* module identifier */
const __vue_module_identifier__$e = undefined;
/* functional template */
const __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

const DEFAULT_APPLICATION_ROLE = 'predefined_1';
const SUBSCRIPTION_USER_ROLE = 'predefined_sub_2';
const SUBSCRIPTION_ADMIN_ROLE = 'predefined_sub_1';
const SHARE_SEGMENTS_ROLE = 'predefined_sub_3';
const SHARE_REPORTS_ROLE = 'predefined_sub_4';
const SUPER_ROLE = 'super';
const GLOBAL_ACCESS_ROLE = 'global_access';
const OPS_ROLE = 'ops';
const ADOPT_MANAGER_ROLE = 'adopt_manager_sub_role';
const VOC_VIEWER_ROLE = 'voc_viewer_role';
const VOC_MANAGER_ROLE = 'predefined_sub_6';
const VOC_CONTRIBUTOR_ROLE = 'predefined_sub_7';
const RESOURCE_CENTER_PERMISSION_SETS = ['7', '8', '9', '24'];
const ROLE_MAP = {
  default: {
    name: 'Learn More About Roles & Permissions',
    description: 'Hover over any of the default or custom roles above to learn about them. As you create custom roles, the descriptions will show in this area to provide a quick reference for you.'
  },
  sunrise_default: {
    name: 'Learn More About Roles & Permissions',
    description: 'Hover over any of the roles above to learn about them.'
  },
  predefined_1: {
    name: 'Viewer',
    description: ['This is the base level user role', 'Viewers can view metrics across the application']
  },
  predefined_2: {
    name: 'Guide Publisher',
    description: ['Publish & Schedule Guides', 'Delete Non-Public Guides']
  },
  predefined_3: {
    name: 'Guide Creator',
    description: ['Create & Edit Guides', 'Copy and clone existing Guides', 'Delete Non-Public Guides', 'Create, Edit & Delete Pages and Features']
  },
  predefined_4: {
    name: 'Analyst',
    description: ['Create, Edit & Delete Pages and Features']
  },
  predefined_5: {
    name: 'Guide Content Editor',
    description: ['Copy and clone existing Guides', 'Edit Guides', 'Delete Non-Public Guides', 'Create, Edit & Delete Pages and Features']
  },
  predefined_6: {
    name: 'Resource Center Author',
    description: ['Create Resource Center', 'Edit Resource Center']
  },
  predefined_7: {
    name: 'Resource Center Publisher',
    description: ['Promote a Resource Center to Production', 'Demote a Resource Center to Draft or Disabled']
  },
  predefined_sub_6: {
    name: 'Manager',
    description: ['Create Ideas', 'Update all fields on any Idea', 'Delete any Idea', 'Add Votes to Ideas', 'Revoke Votes from any Idea', 'Create Idea Tests (also requires Guide creator permission)', 'Guide publishing (also requires Guide creator permission)']
  },
  predefined_sub_7: {
    name: 'Contributor',
    description: ['Create Ideas', 'Edit the following fields on their Ideas:  Title, Description, App, Cover Image', 'Delete their own Ideas', 'Add Votes to Ideas', 'Revoke Votes they’ve added']
  }
};
const NPS_ROLE_MAP = {
  predefined_2: {
    name: 'Guide Publisher',
    description: ['Publish & Schedule Guides*', 'Delete Guides* in Draft, Staged, Disabled'],
    footnote: '*Guides includes NPS'
  },
  predefined_3: {
    name: 'Guide Creator',
    description: ['Create & Edit Guides* from Scratch', 'Create & Edit Guides* from Layouts (and Templates)', 'Delete Guides* in Draft, Staged, Disabled', 'Create, Edit & Delete Pages and Features', 'Triage NPS Themes - add, remove, edit and assign themes for NPS textual responses'],
    footnote: '*Guides includes NPS'
  },
  predefined_4: {
    name: 'Analyst',
    description: ['Create, Edit & Delete Pages and Features', 'Edit & Delete Track Events']
  },
  predefined_5: {
    name: 'Guide Content Editor',
    description: ['Create Guides* from Themes and Layouts', 'Delete Guides* in Draft, Staged, Disabled', 'Create, Edit & Delete Pages and Features', 'Triage NPS Themes - add, remove, edit and assign themes for NPS textual responses'],
    footnote: '*Guides includes NPS'
  },
  predefined_6: {
    name: 'Resource Center Author',
    description: ['Create Resource Center', 'Edit Resource Center']
  },
  predefined_7: {
    name: 'Resource Center Publisher',
    description: ['Promote a Resource Center to Production', 'Demote a Resource Center to Draft or Disabled']
  }
};
const SHARE_OPTIONS = [{
  id: SHARE_SEGMENTS_ROLE,
  label: 'Share and Edit Segments with Everyone',
  helperText: 'Share segments you’ve created with everyone, and edit segments that have been shared with you.'
}, {
  id: SHARE_REPORTS_ROLE,
  label: 'Share and Edit Reports with Everyone',
  helperText: 'Share reports you’ve created with everyone, and edit reports that have been shared with you.'
}];
const VOC_OPTIONS = [{
  id: VOC_VIEWER_ROLE,
  description: 'Viewer',
  name: 'Viewer',
  isDisabled: true,
  selectionState: 'checked'
}, {
  id: VOC_CONTRIBUTOR_ROLE,
  description: 'Contributor',
  name: 'Contributor',
  selectionState: 'checked'
}, {
  id: VOC_MANAGER_ROLE,
  description: 'Manager',
  name: 'Manager'
}];
const SELECTION_STATE = {
  checked: 'checked',
  indeterminate: 'indeterminate',
  unchecked: 'unchecked'
};

// The roles in this array are not retrieved or sent to the backend
// take special care to filter these out prior to updates, or to add them to the BE results when retrieving roles
const SUPPLEMENTAL_ROLES = [SUBSCRIPTION_USER_ROLE, SUPER_ROLE, OPS_ROLE, ADOPT_MANAGER_ROLE, VOC_VIEWER_ROLE];

// Helper function determines if a role is managed through the api
// ASSUME yes unless the role is one of the ones we list above
function isRoleManagedByAPI(role) {
  return !SUPPLEMENTAL_ROLES.includes(role);
}
function isAdoptSub(subscriptionConfig) {
  return subscriptionConfig.isAdopt || subscriptionConfig.isAEU;
}
function hasResourceCenterPermissionSet(role) {
  if (!role.permissionSets) {
    return false;
  }
  if (role.id === 'predefined_6' || role.id === 'predefined_7') {
    return true;
  }
  return role.permissionSets.some(set => RESOURCE_CENTER_PERMISSION_SETS.includes(set));
}
function buildRoleMapBy(predefinedRoles, prop) {
  return predefinedRoles.reduce((roleNameMap, role) => ({
    [role.id]: prop ? role[prop] : role,
    ...roleNameMap
  }), {});
}
function buildRoleMapWithRoles(roles) {
  const predefinedRoles = roles.filter(({
    type
  }) => type === 'predefined');
  const customRoles = roles.filter(({
    type,
    name
  }) => type === 'custom' && Boolean(name));
  return buildRoleMapBy([...customRoles, ...predefinedRoles], 'name');
}
function buildRoleList(roleIdList, roleNameMap) {
  if (!roleIdList || roleIdList.length === 0) {
    return '';
  }
  const predefinedRoles = [];
  const saveCustomRoles = cloneDeep(roleIdList);
  roleIdList.forEach(role => {
    if (role.includes('predefined')) {
      predefinedRoles.push(role);
      saveCustomRoles.splice(saveCustomRoles.indexOf(role), 1);
    }
  });
  predefinedRoles.sort();
  const sortedRoleIdList = [...predefinedRoles, ...saveCustomRoles];
  return sortedRoleIdList.reduce((roleNames, id) => {
    if (roleNameMap[id]) {
      roleNames.push(roleNameMap[id]);
    }
    return roleNames;
  }, []);
}
function buildRoleListDisplayName(roleIdList, roleNameMap) {
  if (!roleIdList || roleIdList.length === 0) {
    return '';
  }
  return buildRoleList(roleIdList, roleNameMap).join(', ');
}
function buildApplicationPermissionsMap(user, apps, canSelectViewer = false) {
  if (!isEmpty(user) && user.applicationRoles && !isEmpty(user.applicationRoles)) {
    // `user.applicationRoles` array will need to be filtered in the future to handle custom roles
    // role.type === `custom` || `predefined` exists to do so
    let hasDefaultRole = false;
    const applicationRoles = cloneDeep(user.applicationRoles);

    // build `{ appId: [ ...roleIds ] }`
    return apps.reduce((appMap, {
      id
    }) => {
      // empty array of the app doesn't exist in the list because new or other
      const applicationRolesByApp = applicationRoles[id] || [];

      // create roleId list and check if the user already has default role
      const roleIdList = applicationRolesByApp.map(role => {
        const id = role.id || role;
        if (id === DEFAULT_APPLICATION_ROLE) {
          hasDefaultRole = true;
        }
        return id;
      });
      if (!canSelectViewer && (isEmpty(applicationRolesByApp) || !hasDefaultRole)) {
        // add at the front
        roleIdList.unshift(DEFAULT_APPLICATION_ROLE);
      }
      return {
        [id]: roleIdList,
        ...appMap
      };
    }, {});
  }
  const defaultRoles = canSelectViewer ? [] : [DEFAULT_APPLICATION_ROLE];
  return apps.reduce((appMap, {
    id
  }) => ({
    [id]: defaultRoles,
    // base 'Viewer' role as default
    ...appMap
  }), {});
}
function getApplicationRolesBySub(subId, type = '') {
  return http.get(`/api/s/${subId}/applicationrole?type=${type}`).then(res => res.data);
}

/**
 * These nested loops check each application role a user has in each application and removes any custom role that doesn't exist.
 * This only checks users (non-admins), since admins don't have custom roles
 */
function removeNonExistentCustomRoles(userList, roleNameMap) {
  userList.forEach(user => {
    if (user.applicationRoles && !user.flags?.admin) {
      for (const application of Object.values(user.applicationRoles)) {
        for (const [index, roleId] of application.entries()) {
          if (!roleId.includes('predefined') && !Object.keys(roleNameMap).includes(roleId)) {
            application.splice(index, 1);
          }
        }
      }
    }
  });
}
function getRoleSelectionStateAndAppNames(selectedApps, roleId, applicationPermissionsMap, canSelectViewer = false) {
  const selectionStateAndAppNames = {
    selectionState: SELECTION_STATE.unchecked,
    appNames: '',
    appsWithoutRC: ''
  };
  if (selectedApps.length === 0) {
    return selectionStateAndAppNames;
  }
  const appNames = [];
  const appsWithoutRC = [];
  selectedApps.forEach(app => {
    if (applicationPermissionsMap[app.id].indexOf(roleId) > -1) {
      appNames.push(app.displayName);
    }
    if (!app.resourceCenterAccess) {
      appsWithoutRC.push(app.displayName);
    }
  });

  // turn appNames into a string for display
  selectionStateAndAppNames.appNames = appNames.join(', ');
  selectionStateAndAppNames.appsWithoutRC = appsWithoutRC.join(', ');
  const autoEnableViewer = roleId === DEFAULT_APPLICATION_ROLE && !canSelectViewer;
  if (autoEnableViewer || appNames.length === selectedApps.length) {
    selectionStateAndAppNames.selectionState = SELECTION_STATE.checked;
  } else if (appNames.length > 0) {
    selectionStateAndAppNames.selectionState = SELECTION_STATE.indeterminate;
  }
  return selectionStateAndAppNames;
}

const USER_ROLES = {
  PUBLIC: 1,
  USER: 2,
  ADMIN: 4,
  SUPER: 8
};
function isAdminOrAbove(user) {
  return isOps(user) || isSuper(user) || isAdmin(user) || isV2SubAdmin(user);
}
function isOps(user) {
  return isSuper(user) && get(user, 'userflags.opsFlag', false);
}
function isSuper(user) {
  return user.role === USER_ROLES.SUPER;
}
function isAdmin(user) {
  return get(user, 'flags.admin', false);
}
function isV2SubAdmin(user) {
  return !!user.subscriptionRoles?.includes(SUBSCRIPTION_ADMIN_ROLE);
}
function isAdoptManager(user) {
  return isAdmin(user) && get(user, 'flags.adoptManager', false);
}
function isReadOnly(user) {
  return get(user, 'flags.readOnly', false);
}
function isUser(user) {
  if (isReadOnly(user)) {
    return false;
  }
  return user.role === USER_ROLES.USER;
}
function isInvitation(user) {
  return !!user.expirationTimestamp;
}
function isGuest(user) {
  return !!user.expiresAt;
}
function hasGlobalAccess(user) {
  return !!user.globalAccessExpiresAt;
}
function subscriptionRole(user) {
  if (user) {
    if (isOps(user)) {
      return 'Ops';
    }
    if (isSuper(user)) {
      if (hasGlobalAccess(user)) {
        return 'Global Access';
      }
      return 'Super';
    }
    if (isAdmin(user) || isV2SubAdmin(user)) {
      return 'Subscription Admin';
    }
    return 'User';
  }
  return false;
}
function roleName(user) {
  if (isGuest(user)) {
    return 'Guest';
  }
  if (isOps(user)) {
    return 'Ops';
  }
  if (isSuper(user)) {
    if (hasGlobalAccess(user)) {
      return 'Global Access';
    }
    return 'Super';
  }
  if (isAdmin(user)) {
    return 'Admin';
  }
  if (isUser(user)) {
    return 'User';
  }
  return 'Read-Only';
}

//
var script$d = {
  name: 'UserPermissionLevels',
  components: {
    AppRolesList: __vue_component__$e,
    PendoLoadingIndicator
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    apps: {
      type: Array,
      required: true
    },
    subId: {
      type: [Number, String],
      default: ''
    },
    roleNameMap: {
      type: Object,
      default: () => ({})
    },
    showSharing: {
      type: Boolean,
      default: false
    },
    showValidate: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    canSelectViewer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoadingApplicationRoles: false,
      updatedRoleNameMap: {}
    };
  },
  computed: {
    isLoadingLevels() {
      return this.isLoading || this.isLoadingApplicationRoles;
    },
    subscriptionRole() {
      return subscriptionRole(this.user);
    },
    userSubscriptionRoles() {
      return this.user.subscriptionRoles || [];
    },
    hasSharing() {
      return this.userSubscriptionRoles.includes(SHARE_SEGMENTS_ROLE) || this.userSubscriptionRoles.includes(SHARE_REPORTS_ROLE);
    },
    sharingRoles() {
      const subSharingRoles = [];
      if (this.userSubscriptionRoles.includes(SHARE_SEGMENTS_ROLE)) {
        subSharingRoles.push('Share and Edit Segments with Everyone');
      }
      if (this.userSubscriptionRoles.includes(SHARE_REPORTS_ROLE)) {
        subSharingRoles.push('Share and Edit Reports with Everyone');
      }
      return subSharingRoles;
    },
    vocRoles() {
      const subVocRoles = [];
      subVocRoles.push('Viewer');
      if (this.userSubscriptionRoles.includes(VOC_MANAGER_ROLE)) {
        subVocRoles.push('Manager');
      }
      if (this.userSubscriptionRoles.includes(VOC_CONTRIBUTOR_ROLE)) {
        subVocRoles.push('Contributor');
      }
      return subVocRoles;
    },
    applicationPermissionsList() {
      return this.apps.map(({
        id,
        platform,
        displayName
      }) => ({
        id,
        platform,
        displayName,
        roleNames: buildRoleListDisplayName(this.applicationPermissionsMap[id], this.updatedRoleNameMap)
      }));
    },
    applicationPermissionsMap() {
      return buildApplicationPermissionsMap(this.user, this.apps, this.canSelectViewer);
    }
  },
  async created() {
    if (isEmpty(this.roleNameMap)) {
      this.isLoadingApplicationRoles = true;
      const roles = await getApplicationRolesBySub(this.subId);
      this.updatedRoleNameMap = buildRoleMapWithRoles(roles);
      this.isLoadingApplicationRoles = false;
    } else {
      this.updatedRoleNameMap = this.roleNameMap;
    }
  }
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isLoadingLevels ? _c('div', {
    staticClass: "loading-apps",
    attrs: {
      "data-cy": "apps-loader"
    }
  }, [_c('pendo-loading-indicator', {
    attrs: {
      "loading": true,
      "size": "medium",
      "text": "Loading...",
      "text-class": "loading-apps-text"
    }
  })], 1) : _c('div', {
    attrs: {
      "id": "role-info"
    }
  }, [_c('div', {
    staticClass: "all-roles"
  }, [_vm.subscriptionRole !== 'User' && _vm.subscriptionRole !== false ? _c('div', {
    staticClass: "subscription-section"
  }, [_c('p', {
    staticClass: "section-header"
  }, [_vm._v("\n                Subscription Level Roles\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "roles-bullets"
  }, [_c('li', [_vm._v("\n                    " + _vm._s(_vm.subscriptionRole) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _vm.subscriptionRole === 'User' ? _c('div', [_vm.showSharing ? _c('div', {
    staticClass: "sharing-section"
  }, [_c('p', {
    staticClass: "section-header"
  }, [_vm._v("\n                    Segments & Reports\n                ")]), _vm._v(" "), _vm.hasSharing ? _c('ul', {
    staticClass: "roles-bullets"
  }, _vm._l(_vm.sharingRoles, function (role) {
    return _c('li', {
      key: role
    }, [_vm._v("\n                        " + _vm._s(role) + "\n                    ")]);
  }), 0) : _vm._e(), _vm._v(" "), !_vm.hasSharing ? _c('p', {
    staticClass: "no-sharing-perms no-perms"
  }, [_vm._v("\n                    No sharing permissions set.\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.showValidate ? _c('div', {
    staticClass: "voc-section"
  }, [_c('p', {
    staticClass: "section-header"
  }, [_vm._v("\n                    Discover\n                ")]), _vm._v(" "), _c('ul', {
    staticClass: "roles-bullets"
  }, _vm._l(_vm.vocRoles, function (role) {
    return _c('li', {
      key: role
    }, [_vm._v("\n                        " + _vm._s(role) + "\n                    ")]);
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app-roles-section"
  }, [_c('p', {
    staticClass: "section-header"
  }, [_vm._v("\n                    App-Level Roles\n                ")]), _vm._v(" "), _c('app-roles-list', {
    attrs: {
      "apps": _vm.applicationPermissionsList,
      "disable-interaction": ""
    }
  })], 1)]) : _vm._e()])]);
};
var __vue_staticRenderFns__$d = [];

/* style */
const __vue_inject_styles__$d = function (inject) {
  if (!inject) return;
  inject("data-v-9a056264_0", {
    source: ".loading-apps[data-v-9a056264]{padding:32px}.section-header[data-v-9a056264]{user-select:text;text-transform:uppercase;color:#6a6c75;background-color:#f4f4f7;font-weight:700;font-size:12px;line-height:2.3;margin-bottom:0;margin-top:0;padding-left:16px;border-top:1px solid #dadce5;border-bottom:1px solid #dadce5}.roles-bullets[data-v-9a056264]{margin:18px 0;font-size:14px}.no-perms[data-v-9a056264]{margin:18px 16px;font-size:14px}[data-v-9a056264] .scrollable-list{padding:16px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$d = "data-v-9a056264";
/* module identifier */
const __vue_module_identifier__$d = undefined;
/* functional template */
const __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

function getRemovalAction(user) {
  if (user.expirationTimestamp) {
    if (user.expirationTimestamp > Date.now()) {
      return 'Revoke';
    }
    return 'Remove';
  }
  return 'Delete';
}
function getRemovalStatement(user) {
  const action = getRemovalAction(user);
  let type;
  if (user.expirationTimestamp) {
    type = 'Invite';
  } else {
    type = 'User';
  }
  return `${action} ${type}`;
}
function normalizeUserFields(user) {
  if (!isEmpty(user)) {
    if (user.firstName) {
      user.first = user.firstName;
    }
    if (user.lastName) {
      user.last = user.lastName;
    }
    user.first = user.first || '';
    user.last = user.last || '';
  }
  return user;
}
function removeUser({
  userId,
  subId
}) {
  return http.delete(`/api/s/${subId}/user/${userId}`);
}
function removeInvite({
  invitationId,
  subId
}) {
  return http.delete(`api/s/${subId}/invitations/${invitationId}`);
}
function updateUser({
  subId,
  user
}) {
  return http.put(`/api/s/${subId}/user/${user.id}`, user).then(res => res.data);
}
function createUser({
  subId,
  user
}) {
  return http.post(`/api/s/${subId}/user`, user).then(res => res.data);
}
function updateUserFlag({
  subId,
  userId
}, {
  flagName,
  value
}) {
  return http.put(`/api/s/${subId}/user/${userId}/flag/${flagName}`, {
    set: value
  }).then(res => res.data);
}
function updateFeedbackVendorUserForUser({
  subId,
  userId,
  vendorUserPermissionId,
  first,
  last
}) {
  return http.patch(`/api/s/${subId}/user/${userId}/feedback/vendoruser`, {
    vendorUserPermissionId,
    first,
    last
  }).then(res => res.data);
}
async function updateFlags({
  subId,
  user,
  flags
}) {
  try {
    const {
      falseRequests,
      trueRequests,
      adminChangeRequest
    } = Object.entries(flags).reduce((acc, flagPair) => {
      const [flagName, flagValue] = flagPair;
      if (flagName === 'systemUser') {
        return acc;
      }
      if (flagName === 'admin') {
        acc.adminChangeRequest = {
          flagName,
          value: flagValue
        };
        return acc;
      }
      acc[flagValue === true ? 'trueRequests' : 'falseRequests'].push({
        flagName,
        value: flagValue
      });
      return acc;
    }, {
      adminChangeRequest: null,
      falseRequests: [],
      trueRequests: []
    });

    // If we're going to admin, do it first so certain flag combinations are allowed
    if (adminChangeRequest && adminChangeRequest.value === true) {
      await updateUserFlag({
        userId: user.id,
        subId
      }, adminChangeRequest);
    }
    await Promise.all(falseRequests.map(falseRequestPair => updateUserFlag({
      userId: user.id,
      subId
    }, falseRequestPair)));
    await Promise.all(trueRequests.map(trueRequestsPair => updateUserFlag({
      userId: user.id,
      subId
    }, trueRequestsPair)));
    // If we're going from admin, do it last after we removed disallowed certain flag combinations
    if (adminChangeRequest && adminChangeRequest.value === false) {
      await updateUserFlag({
        userId: user.id,
        subId
      }, adminChangeRequest);
    }
  } catch (error) {
    throw error;
  }
}

function sortByName(a, b) {
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }
  if (a.name.toLowerCase() > b.name.toLowerCase()) {
    return 1;
  }
  return 0;
}

const DATE_FORMAT = {
  iso: 'YYYY-MM-DD',
  // 2020-04-04
  full: 'MMM D, YYYY h:mm:ss A z'
};

/**
 * Call this function with the same parameters as standard Moment.
 * Optionally, include a plain object with customization options as the final argument:
 *
 * - ignoreTimeZone: Interpret the given date in the browser's local time zone, rather than the subscription time zone.
 *                   This parameter essentially disables all of the customization that this wrapper provides.
 *
 * For example, if the subscription timezone is Asia/Taipei and local timezone is America/Toronto:
 *
 *     var b = MomentWrapper("2013-11-18 11:55");                            // November 19, 00:55 in Taipei (Nov 18, 11:55 Toronto time converted to Taipei)
 *     var c = MomentWrapper("2013-11-18 11:55", { ignoreTimeZone: true });  // November 18, 11:55 in Toronto
 *
 * Moments b and c have the same Unix timestamp associated with them, but a different date string.
 */
function moment (timeZone, ...args) {
  const customArgs = args[args.length - 1]; // take the last argument so that the rest of moment works as normal
  if (customArgs && customArgs.ignoreTimeZone) {
    args.splice(args.length - 1);
    return moment$1(...args);
  }
  if (timeZone) {
    return moment$1(...args).tz(timeZone);
  }
  return moment$1(...args);
}

//
var script$c = {
  name: 'UsersTableView',
  components: {
    PendoAlert,
    PendoCheckboxOption,
    PendoMultiselect,
    PendoTable,
    PendoButton,
    PendoIcon,
    PendoFilterBar,
    PendoInput,
    PendoTag
  },
  directives: {
    PendoTooltip,
    PendoAffix,
    PendoNotification
  },
  props: {
    isScimEnabled: {
      type: Boolean,
      default: false
    },
    productLines: {
      type: Object,
      required: true
    },
    activeUser: {
      type: Object,
      required: true
    },
    subscription: {
      type: Object,
      required: true
    },
    subscriptionConfig: {
      type: Object,
      default: () => ({})
    },
    userList: {
      type: Array,
      required: true
    },
    apps: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    roleNameMap: {
      type: Object,
      required: true
    },
    productType: {
      type: String,
      required: true
    },
    storybookMock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      multiselectStatusList: [{
        name: 'Active'
      }, {
        name: 'Pending'
      }, {
        name: 'Expired'
      }],
      selectedRoles: null,
      selectedStatus: null,
      updatingUser: false,
      searchInput: '',
      defaultSort: {
        prop: 'username',
        order: 'ascending'
      }
    };
  },
  computed: {
    allRolesFlattened() {
      return this.multiselectRolesList.filter(roles => roles.roles.length > 0).flatMap(roles => roles.roles);
    },
    columns() {
      return [{
        prop: 'username',
        label: 'Username',
        sortable: true,
        width: 270
      }, {
        prop: 'role',
        label: this.permissionsColumnName,
        sortable: !this.hasV2RolesAndPermissionsWithFeatureArea,
        sortBy: row => this.roleName(row)
      }, this.subscriptionConfig.feedbackUnifiedLoginEnabled && {
        prop: 'vendorUserPermissionId',
        label: this.feedbackPermissionGroupColumnName,
        sortable: true,
        formatter: row => this.getPermissionGroupName(row.vendorUserPermissionId)
      }, {
        prop: 'lastLogin',
        label: 'Last Login',
        sortable: true,
        sortBy: row => row.lastLogin,
        width: 240
      }, {
        prop: 'actions',
        type: 'actions',
        width: 90
      }].filter(Boolean);
    },
    permissionsColumnName() {
      const roleOrPermissions = this.hasV2RolesAndPermissionsWithFeatureArea ? 'Permissions' : 'Role';
      const isProductTypeEngage = this.productType === 'Engage';
      const columnName = isProductTypeEngage ? `${this.productLines.core.displayName} ${roleOrPermissions}` : 'Permissions';
      return columnName;
    },
    feedbackPermissionGroupColumnName() {
      return `${this.productLines.feedback.displayName} Permission Group`;
    },
    hasFeedback() {
      if (this.userList) {
        return this.userList.some(user => user.vendorUserPermissionId);
      }
      return false;
    },
    hasV2RolesAndPermissionsWithFeatureArea() {
      return isUndefined(this.subscriptionConfig.hasV2RolesAndPermissionsWithFeatureArea) || this.subscriptionConfig.hasV2RolesAndPermissionsWithFeatureArea;
    },
    showStatusMultiselect() {
      return !this.isScimEnabled && this.productType === 'Engage';
    },
    isPendoInternal() {
      return this.subscription.name === 'pendo-internal';
    },
    filters() {
      const filters = [{
        prop: ['username'],
        type: 'includes',
        value: this.searchInput
      }];
      if (!(this.selectedRoles === null || this.selectedRoles.length === this.allRolesFlattened.length)) {
        filters.push({
          filterFn: row => this.filteredUsersList(row)
        });
      }
      if (this.selectedStatus === null) {
        return filters;
      }
      filters.push({
        filterFn: row => this.filteredStatusList(row)
      });
      return filters;
    },
    multiselectRolesList() {
      const defaultRoles = [{
        name: 'Subscription Admin',
        type: 'predefined'
      }];
      const customRoles = [];
      const feedbackRoles = [];
      let pendoRoles = [];
      let mapIncludesViewer = false;
      for (const key in this.roleNameMap) {
        if (key.includes('predefined')) {
          if (this.roleNameMap[key] === 'Viewer') {
            mapIncludesViewer = true;
          } else {
            defaultRoles.push({
              name: this.roleNameMap[key],
              type: 'predefined'
            });
          }
        } else if (this.subscriptionConfig.enableCustomUserRoles) {
          customRoles.push({
            name: this.roleNameMap[key],
            type: 'custom'
          });
        }
      }
      defaultRoles.sort(sortByName);
      customRoles.sort(sortByName);
      if (!this.subscriptionConfig.enableViewerPermission || mapIncludesViewer) {
        defaultRoles.unshift({
          name: 'Viewer',
          type: 'predefined'
        });
      }
      if (this.hasFeedback) {
        for (const feedbackPermissionGroup of this.permissionGroups) {
          if (feedbackPermissionGroup.name) {
            feedbackRoles.push({
              name: feedbackPermissionGroup.name,
              type: 'feedback'
            });
          }
        }
        feedbackRoles.sort(sortByName);
      }
      if (isOps(this.activeUser) || isSuper(this.activeUser)) {
        pendoRoles = [{
          name: 'Super',
          type: 'predefined'
        }, {
          name: 'Ops',
          type: 'predefined'
        }, {
          name: 'Global Access',
          type: 'predefined'
        }];
      }
      return [defaultRoles.length && {
        name: 'default roles',
        roles: defaultRoles
      }, customRoles.length && {
        name: 'custom roles',
        roles: customRoles
      }, feedbackRoles.length && {
        name: 'feedback',
        roles: feedbackRoles
      }, pendoRoles.length && {
        name: 'pendo roles',
        roles: pendoRoles
      }].filter(Boolean);
    },
    permissionGroups() {
      return values(this.subscriptionConfig.permissionGroupMap);
    },
    showRoleClearAction() {
      return !!this.selectedRoles;
    },
    showStatusClearAction() {
      return !!this.selectedStatus;
    },
    tableData() {
      if (this.userList) {
        let formattedList;
        if (this.hasV2RolesAndPermissionsWithFeatureArea) {
          formattedList = this.userList.map(user => {
            if (isAdminOrAbove(user)) {
              user.computedRoleName = subscriptionRole(user);
            } else if (user.applicationRoles && !isEmpty(user.applicationRoles)) {
              user.computedRoleName = 'User';
            } else {
              user.computedRoleName = this.isActive(user) ? 'V1 User' : '';
            }
            return user;
          });
        } else {
          formattedList = this.userList.map(user => {
            user.computedRoleName = roleName(user);
            return user;
          });
        }
        return formattedList;
      }
      return [];
    }
  },
  watch: {
    selectedRoles(role) {
      if (!role || isEmpty(role)) {
        this.selectedRoles = null;
      }
    },
    selectedStatus(status) {
      if (!status || isEmpty(status)) {
        this.selectedStatus = null;
      }
    }
  },
  created() {
    this.$emit('load-users', {
      reFetch: this.isScimEnabled
    });
    this.$emit('load-permission-groups');
  },
  methods: {
    getRemovalAction,
    isGuest,
    isSuper,
    createFilterLabel(options, type) {
      if (options.length > 1) {
        return `${type} (${options.length})`;
      }
      if (options.length === 1) {
        return options[0].name;
      }
    },
    filteredStatusList(row) {
      const selectedStatusNames = this.selectedStatus.map(item => item.name);
      const hasPending = selectedStatusNames.includes('Pending') && this.isPending(row);
      const hasActive = selectedStatusNames.includes('Active') && this.isActive(row);
      const hasExpired = selectedStatusNames.includes('Expired') && this.isExpired(row);
      return hasPending || hasActive || hasExpired;
    },
    filteredUsersList(row) {
      const selectedRoleNames = this.selectedRoles.map(item => item.name);
      const selectedRoleTypes = this.selectedRoles.map(item => item.type);
      const isSuperRole = selectedRoleNames.includes('Super') && subscriptionRole(row) === 'Super';
      const isOpsRole = selectedRoleNames.includes('Ops') && subscriptionRole(row) === 'Ops';
      const isGlobalAccessRole = selectedRoleNames.includes('Global Access') && subscriptionRole(row) === 'Global Access';
      const isSubAdminRole = selectedRoleNames.includes('Subscription Admin') && subscriptionRole(row) === 'Subscription Admin';
      let isPredefinedOrCustomRole = false;
      if ((selectedRoleTypes.includes('predefined') || selectedRoleTypes.includes('custom')) && subscriptionRole(row) === 'User') {
        const userAppLevelRolesList = this.generateUserAppLevelRolesList(row);
        const filteredRoles = selectedRoleNames.filter(name => userAppLevelRolesList.has(name));
        isPredefinedOrCustomRole = filteredRoles.length > 0;
      }
      const isFeedbackType = selectedRoleTypes.includes('feedback') && selectedRoleNames.includes(this.getPermissionGroupName(row.vendorUserPermissionId));
      return isSuperRole || isOpsRole || isGlobalAccessRole || isSubAdminRole || isFeedbackType || isPredefinedOrCustomRole;
    },
    isActive(row) {
      return row.lastLogin || this.hasNotLoggedIn(row);
    },
    isExpired(row) {
      return !this.isActive(row) && row.expirationTimestamp <= Date.now();
    },
    isPending(row) {
      return !this.isActive(row) && row.expirationTimestamp > Date.now();
    },
    formatLastLogin(row) {
      if (row.lastLogin) {
        return moment(this.subscription.timeZone, row.lastLogin).format(DATE_FORMAT.full);
      }
      if (this.hasNotLoggedIn(row)) {
        return '--';
      }
      return row.expirationTimestamp > Date.now() ? 'Invite Pending' : 'Invite Expired';
    },
    userToRow(user) {
      if (!user || isEmpty(user)) {
        return [];
      }
      let row = [user.username, this.subscription.name];
      if (this.showMoreUserDetails(user)) {
        row = row.concat(this.apps.map(app => {
          if (!user.applicationRoles[app.id]) {
            return '';
          }
          return `"${user.applicationRoles[app.id].map(roleId => {
            return this.roleNameMap[roleId] || '';
          }).join(', ')}"`;
        }));
      } else {
        row = row.concat(this.apps.map(() => `"${user.computedRoleName}"`));
      }
      if (this.hasFeedback) {
        if (user.vendorUserPermissionId) {
          const permissionGroupName = this.getPermissionGroupName(user.vendorUserPermissionId);
          row.push(permissionGroupName);
        } else {
          row.push('');
        }
      }
      row.push(`"${this.formatLastLogin(user)}"`);
      return row;
    },
    downloadArrayAsCSV(rows) {
      const csvContent = `data:text/csv;charset=utf-8,${rows.map(row => row.join(',')).join('\n')}`;
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'user-permissions.csv');
      document.body.appendChild(link);
      link.click();
    },
    downloadCSV() {
      const headers = ['Username', 'Subscription', ...this.apps.map(({
        displayName,
        name
      }) => displayName || name)];
      if (this.hasFeedback) {
        headers.push('Feedback');
      }
      headers.push('Last Login');
      const dataRows = this.tableData.reduce((data, user) => {
        if (user && user.username.includes(this.searchInput)) {
          data.push(this.userToRow(user));
        }
        return data;
      }, []);
      this.downloadArrayAsCSV([headers, ...dataRows]);
    },
    getPermissionGroupName(permissionGroupId) {
      return get(this.subscriptionConfig.permissionGroupMap[permissionGroupId], 'name', '');
    },
    guestTooltip(user) {
      if (isGuest(user)) {
        return {
          content: `Guest until ${moment(this.subscription.timeZone, user.expiresAt).format('M/D/YYYY h:mm a')}`,
          arrow: true
        };
      }
      return false;
    },
    numOfUniqueRolesDisplayName(user) {
      const numberOfRoles = uniq(Object.keys(user.applicationRoles).reduce((roleIds, appId) => roleIds.concat(user.applicationRoles[appId]), [])).length;
      const roleOrRoles = numberOfRoles > 1 ? 'roles' : 'role';
      return `${numberOfRoles} ${roleOrRoles}`;
    },
    generateUserAppLevelRolesList(user) {
      const userAppLevelRolesList = new Set();
      if (user.applicationRoles) {
        for (const application of Object.values(user.applicationRoles)) {
          for (const roleId of application) {
            userAppLevelRolesList.add(this.roleNameMap[roleId]);
          }
        }
      }
      return userAppLevelRolesList;
    },
    filterSearch(searchInput) {
      this.searchInput = searchInput;
    },
    canEdit(userToEdit) {
      if (userToEdit.id === this.activeUser.id) {
        return false;
      }
      if (isOps(this.activeUser)) {
        return true;
      }
      if (isSuper(userToEdit) || isOps(userToEdit)) {
        return false;
      }
      return isAdmin(this.activeUser) || isSuper(this.activeUser);
    },
    disabledEditTooltip(userToEdit) {
      if (userToEdit.id === this.activeUser.id) {
        return {
          arrow: true,
          content: 'Please contact another Admin <br/>to update your permissions.',
          html: true
        };
      }
      if (isSuper(userToEdit) || isOps(userToEdit)) {
        const content = this.isPendoInternal ? `Only OPS can edit ${isOps(userToEdit) ? 'OPS' : 'SUPER'} users.` : 'This is an approved Pendo Employee that has been granted access to your subscription. ' + 'You cannot update their permissions, however you can remove this user.';
        return {
          arrow: true,
          content,
          multiline: true
        };
      }
      return false;
    },
    canDelete(userToDelete) {
      if (userToDelete.id === this.activeUser.id) {
        return false;
      }
      if (this.isPendoInternal && (isSuper(userToDelete) || isOps(userToDelete))) {
        return isOps(this.activeUser);
      }
      return isAdmin(this.activeUser) || isSuper(this.activeUser) || isOps(this.activeUser);
    },
    disabledDeleteTooltip(userToDelete) {
      if (userToDelete.id === this.activeUser.id) {
        return {
          arrow: true,
          content: 'Please contact another Admin <br/>to remove you from this subscription.',
          html: true
        };
      }
      if (this.isPendoInternal && (isSuper(userToDelete) || isOps(userToDelete))) {
        return {
          arrow: true,
          content: `Only OPS can remove ${isOps(userToDelete) ? 'OPS' : 'SUPER'} users.`,
          multiline: true
        };
      }
      return false;
    },
    scimDisableDeleteTooltip() {
      return {
        arrow: true,
        content: 'Your users are managed via SCIM therefore <br/>deleting users is not available in Pendo.',
        html: true
      };
    },
    scimDisableEditTooltip() {
      return {
        arrow: true,
        content: 'Your users are managed via SCIM therefore <br/>editing users is not available in Pendo.',
        html: true
      };
    },
    openSidePanel(user) {
      this.$emit('open-side-panel', user);
    },
    openUserModal(user) {
      this.$emit('open-user-modal', user);
    },
    showDeleteModal(user) {
      this.$emit('show-delete-modal', user);
    },
    onResend(user) {
      this.invite(user);
    },
    async invite(user) {
      if (this.storybookMock) {
        return;
      }
      const {
        username: email,
        first,
        last,
        applicationRoles = {},
        subscriptionRoles
      } = user;
      try {
        this.updatingUser = true;
        await createUser({
          subId: this.subscription.id,
          user: {
            email,
            role: 2,
            first,
            last,
            applicationRoles,
            subscriptionRoles,
            ...(user.vendorUserPermissionId ? {
              permissiongroupid: user.vendorUserPermissionId
            } : {})
          }
        });
        PendoNotification({
          type: 'success',
          message: `${user.username} has been reinvited.`
        });
        this.$emit('user-invited');
      } catch (err) {
        if (err.response.status === 409) {
          PendoNotification({
            type: 'error',
            message: `Your request failed. ${user.username} already exists in this subscription.`
          });
        } else if (err.response.status === 429) {
          PendoNotification({
            type: 'error',
            message: `${user.username} has already been reinvited.`
          });
        } else {
          PendoNotification({
            type: 'error',
            message: `Your request failed. Unable to reinvite ${user.username} at this time.\n${err}`
          });
        }
      }
      this.updatingUser = false;
    },
    // eslint-disable-next-line vue/no-unused-properties
    removeRow(row) {
      this.$refs.pendoUserTable.removeRow(row);
    },
    numOfAppsDisplayName(user) {
      let numberOfApps = 0;
      this.apps.forEach(app => {
        const appId = app.id;
        const rolesList = user.applicationRoles[appId];
        if (rolesList && rolesList.length) {
          numberOfApps++;
        }
      });
      const appOrApps = numberOfApps > 1 ? 'apps' : 'app';
      return `${numberOfApps} ${appOrApps}`;
    },
    getTagType(row) {
      return row.expirationTimestamp > Date.now() ? 'warning' : 'info';
    },
    getTagSubtle(row) {
      return !(row.expirationTimestamp > Date.now());
    },
    hasNotLoggedIn(row) {
      return !isUndefined(row.hasLoggedIn) && !row.hasLoggedIn;
    },
    showMoreUserDetails(row) {
      return this.hasV2RolesAndPermissionsWithFeatureArea && row.computedRoleName === 'User';
    },
    clearSelectedRoles() {
      this.selectedRoles = null;
    },
    clearSelectedStatuses() {
      this.selectedStatus = null;
    },
    selectAllRoles() {
      this.selectedRoles = this.allRolesFlattened;
    },
    selectAllStatuses() {
      this.selectedStatus = this.multiselectStatusList;
    }
  }
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('pendo-filter-bar', {
    directives: [{
      name: "pendo-affix",
      rawName: "v-pendo-affix",
      value: {
        relativeToRoot: true,
        fixedStyles: {
          left: 0,
          right: 0,
          padding: '3px 32px'
        }
      },
      expression: "{\n            relativeToRoot: true,\n            fixedStyles: {\n                left: 0,\n                right: 0,\n                padding: '3px 32px'\n            }\n        }"
    }],
    staticClass: "filter-bar"
  }, [_vm.hasV2RolesAndPermissionsWithFeatureArea ? _c('pendo-multiselect', {
    staticClass: "role-multiselect",
    attrs: {
      "multiple": "",
      "close-on-select": false,
      "clear-on-select": false,
      "max-menu-width": 204,
      "option-height": 30,
      "show-selected-values": false,
      "searchable": false,
      "options": _vm.multiselectRolesList,
      "placeholder": "All Roles",
      "group-options-key": "roles",
      "group-label-key": "name",
      "value-key": "name",
      "label-key": "name"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm.showRoleClearAction ? _c('pendo-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": _vm.clearSelectedRoles
          }
        }, [_vm._v("\n                    Clear\n                ")]) : _vm._e(), _vm._v(" "), !_vm.showRoleClearAction ? _c('pendo-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": _vm.selectAllRoles
          }
        }, [_vm._v("\n                    Select All\n                ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "option",
      fn: function (ref) {
        var option = ref.option;
        return [_c('pendo-checkbox-option', {
          attrs: {
            "data-cy": option.name,
            "option": option
          }
        })];
      }
    }, {
      key: "selectedLabel",
      fn: function (ref) {
        var option = ref.option;
        return [_vm._v("\n                " + _vm._s(_vm.createFilterLabel(option, 'Roles')) + "\n            ")];
      }
    }], null, false, 1794399330),
    model: {
      value: _vm.selectedRoles,
      callback: function ($$v) {
        _vm.selectedRoles = $$v;
      },
      expression: "selectedRoles"
    }
  }) : _vm._e(), _vm._v(" "), _vm.showStatusMultiselect ? _c('pendo-multiselect', {
    staticClass: "status-multiselect",
    attrs: {
      "multiple": "",
      "placeholder": "All Statuses",
      "show-selected-values": false,
      "max-menu-width": 204,
      "option-height": 30,
      "close-on-select": false,
      "clear-on-select": false,
      "searchable": false,
      "options": _vm.multiselectStatusList,
      "value-key": "name",
      "label-key": "name"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_vm.showStatusClearAction ? _c('pendo-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": _vm.clearSelectedStatuses
          }
        }, [_vm._v("\n                    Clear\n                ")]) : _vm._e(), _vm._v(" "), !_vm.showStatusClearAction ? _c('pendo-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": _vm.selectAllStatuses
          }
        }, [_vm._v("\n                    Select All\n                ")]) : _vm._e()];
      },
      proxy: true
    }, {
      key: "option",
      fn: function (ref) {
        var option = ref.option;
        return [_c('pendo-checkbox-option', {
          attrs: {
            "option": option
          }
        })];
      }
    }, {
      key: "selectedLabel",
      fn: function (ref) {
        var option = ref.option;
        return [_vm._v("\n                " + _vm._s(_vm.createFilterLabel(option, 'Statuses')) + "\n            ")];
      }
    }], null, false, 2584895900),
    model: {
      value: _vm.selectedStatus,
      callback: function ($$v) {
        _vm.selectedStatus = $$v;
      },
      expression: "selectedStatus"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.hasV2RolesAndPermissionsWithFeatureArea || _vm.showStatusMultiselect ? 'user-page-filter-bar-v2-permissions' : 'user-page-filter-bar'
  }, [_c('pendo-input', {
    staticClass: "search-input",
    class: {
      'search-input--full-width': !_vm.hasV2RolesAndPermissionsWithFeatureArea && !_vm.showStatusMultiselect
    },
    attrs: {
      "data-cy": "user-search-input",
      "placeholder": "Search"
    },
    on: {
      "input": _vm.filterSearch
    },
    scopedSlots: _vm._u([{
      key: "prefix",
      fn: function () {
        return [_c('pendo-icon', {
          attrs: {
            "type": "search",
            "stroke": "#2a2c35",
            "size": "16"
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.searchInput,
      callback: function ($$v) {
        _vm.searchInput = $$v;
      },
      expression: "searchInput"
    }
  })], 1)], 1), _vm._v(" "), _vm.isScimEnabled ? _c('pendo-alert', {
    staticClass: "scim-warning",
    attrs: {
      "type": "warning",
      "title": "Your users are managed via SCIM therefore some fields may not be editable in Pendo or may be overridden."
    }
  }) : _vm._e(), _vm._v(" "), _c('pendo-table', {
    ref: "pendoUserTable",
    attrs: {
      "title": "Users",
      "loading-text": "Loading...",
      "row-key": "id",
      "csv-download": _vm.downloadCSV,
      "loading": _vm.isLoading,
      "data": _vm.tableData,
      "filters": _vm.filters,
      "columns": _vm.columns,
      "auto-height": "",
      "default-sort": _vm.defaultSort
    },
    scopedSlots: _vm._u([{
      key: "username",
      fn: function (ref) {
        var row = ref.row;
        return [_c('div', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: !_vm.canEdit(row) && _vm.disabledEditTooltip(row),
            expression: "!canEdit(row) && disabledEditTooltip(row)"
          }],
          staticClass: "button-tooltip"
        }, [_c('pendo-button', {
          attrs: {
            "theme": "app",
            "type": "link",
            "disabled": !_vm.canEdit(row),
            "label": row.username,
            "data-cy": "username-" + row.id + "-link"
          },
          on: {
            "click": function ($event) {
              return _vm.openSidePanel(row);
            }
          }
        }, [_c('span', {
          class: {
            'super-user-icon': _vm.isSuper(row)
          }
        }, [_vm._v(_vm._s(row.username))])])], 1)];
      }
    }, {
      key: "role",
      fn: function (ref) {
        var row = ref.row;
        return [_c('div', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: _vm.guestTooltip(row),
            expression: "guestTooltip(row)"
          }],
          staticClass: "user-role"
        }, [_vm.isGuest(row) ? _c('pendo-icon', {
          staticClass: "guest-icon",
          attrs: {
            "type": "clock",
            "size": "12"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "user-role-name"
        }, [_vm._v("\n                    " + _vm._s(row.computedRoleName) + "\n                    "), _vm.showMoreUserDetails(row) ? _c('span', [_vm._v(": " + _vm._s(_vm.numOfUniqueRolesDisplayName(row)) + " across " + _vm._s(_vm.numOfAppsDisplayName(row)) + "\n                    ")]) : _vm._e(), _vm._v(" "), _vm.showMoreUserDetails(row) ? _c('pendo-button', {
          staticClass: "permission-detail-link",
          attrs: {
            "label": "View Details",
            "type": "link",
            "disabled": !_vm.canEdit(row)
          },
          on: {
            "click": function ($event) {
              return _vm.openSidePanel(row);
            }
          }
        }) : _vm._e()], 1)], 1)];
      }
    }, {
      key: "lastLogin",
      fn: function (ref) {
        var row = ref.row;
        return [_vm.isActive(row) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.formatLastLogin(row)) + "\n            ")]) : _c('div', [_c('pendo-tag', {
          attrs: {
            "label": _vm.formatLastLogin(row),
            "type": _vm.getTagType(row),
            "subtle": _vm.getTagSubtle(row),
            "round": true
          }
        })], 1)];
      }
    }, {
      key: "actions",
      fn: function (ref) {
        var row = ref.row;
        return [_c('div', [_vm.isExpired(row) ? _c('pendo-button', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              content: 'Resend',
              boundariesElement: 'viewport'
            },
            expression: "{ content: 'Resend', boundariesElement: 'viewport' }"
          }],
          staticClass: "hover-styling",
          attrs: {
            "icon": "rotate-cw",
            "theme": "app",
            "disabled": _vm.updatingUser,
            "type": "tertiary",
            "icon-size": "12"
          },
          on: {
            "click": function ($event) {
              return _vm.onResend(row);
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: _vm.isScimEnabled && _vm.scimDisableEditTooltip() || !_vm.canEdit(row) && _vm.isActive(row) && _vm.disabledEditTooltip(row),
            expression: "\n                    (isScimEnabled && scimDisableEditTooltip()) ||\n                        (!canEdit(row) && isActive(row) && disabledEditTooltip(row))\n                "
          }],
          staticClass: "button-tooltip"
        }, [_c('pendo-button', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: _vm.isScimEnabled || !_vm.canEdit(row) ? '' : {
              content: 'Edit',
              boundariesElement: 'viewport'
            },
            expression: "\n                        isScimEnabled || !canEdit(row) ? '' : { content: 'Edit', boundariesElement: 'viewport' }\n                    "
          }],
          staticClass: "hover-styling",
          attrs: {
            "icon": "edit",
            "theme": "app",
            "disabled": _vm.isScimEnabled || !_vm.canEdit(row),
            "data-cy": "edit-" + row.id + "-link",
            "type": "tertiary",
            "icon-size": "12"
          },
          on: {
            "click": function ($event) {
              return _vm.openUserModal(row);
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: _vm.isScimEnabled && _vm.scimDisableDeleteTooltip() || !_vm.canDelete(row) && _vm.disabledDeleteTooltip(row),
            expression: "\n                    (isScimEnabled && scimDisableDeleteTooltip()) || (!canDelete(row) && disabledDeleteTooltip(row))\n                "
          }],
          staticClass: "button-tooltip"
        }, [_c('pendo-button', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: _vm.isScimEnabled || !_vm.canDelete(row) ? '' : {
              content: _vm.getRemovalAction(row),
              boundariesElement: 'viewport'
            },
            expression: "\n                        isScimEnabled || !canDelete(row)\n                            ? ''\n                            : { content: getRemovalAction(row), boundariesElement: 'viewport' }\n                    "
          }],
          staticClass: "hover-styling",
          attrs: {
            "icon": "trash-2",
            "theme": "app",
            "disabled": _vm.isScimEnabled || !_vm.canDelete(row),
            "data-cy": "delete-" + row.id + "-link",
            "type": "tertiary",
            "icon-size": "12"
          },
          on: {
            "click": function ($event) {
              return _vm.showDeleteModal(row);
            }
          }
        })], 1)];
      }
    }])
  })], 1);
};
var __vue_staticRenderFns__$c = [];

/* style */
const __vue_inject_styles__$c = function (inject) {
  if (!inject) return;
  inject("data-v-7237b2e6_0", {
    source: ".filter-bar[data-v-7237b2e6]{margin:0 0 16px}.filter-bar .role-multiselect[data-v-7237b2e6],.filter-bar .status-multiselect[data-v-7237b2e6]{margin-right:16px}.pendo-multiselect__header .pendo-button[data-v-7237b2e6]{margin:0 16px}.search-input[data-v-7237b2e6]{max-width:208px}.search-input.search-input--full-width[data-v-7237b2e6]{max-width:100%}.scim-warning[data-v-7237b2e6]{margin-bottom:16px}.button-tooltip[data-v-7237b2e6]{display:inline-block}.user-role[data-v-7237b2e6]{justify-content:flex-start;display:flex;align-items:center;gap:8px;width:fit-content}.user-role .user-role-name[data-v-7237b2e6]{display:block}.user-role .user-role-name .guest-icon[data-v-7237b2e6]{margin-right:5px}.user-page-filter-bar[data-v-7237b2e6]{width:100%}.user-page-filter-bar-v2-permissions[data-v-7237b2e6]{margin-left:auto;width:200px}.super-user-icon[data-v-7237b2e6]::before{background-image:url(https://cdn.pendo.io/img/pendo-chevron.svg);content:\"\";display:inline-block;vertical-align:middle;width:1em;height:1em;margin-right:.5em}.permission-detail-link[data-v-7237b2e6]{display:block;height:unset;line-height:14px;font-size:12px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$c = "data-v-7237b2e6";
/* module identifier */
const __vue_module_identifier__$c = undefined;
/* functional template */
const __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);

var index = {
  buildRoleMapWithRoles,
  removeNonExistentCustomRoles
};

//
var script$b = {
  name: 'UserSidePanel',
  components: {
    PendoDrawer,
    PendoDrawerClose,
    PendoButton,
    UserPermissionLevels: __vue_component__$d
  },
  directives: {
    PendoTooltip
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    apps: {
      type: Array,
      required: true
    },
    canSelectViewer: {
      type: Boolean,
      default: false
    },
    roleNameMap: {
      type: Object,
      default: () => ({})
    },
    showSharing: {
      type: Boolean,
      default: false
    },
    showValidate: {
      type: Boolean,
      default: false
    },
    subId: {
      type: [Number, String],
      required: true
    },
    isScimEnabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    userAction() {
      return getRemovalAction(this.user);
    },
    userFullName() {
      return `${this.user.first} ${this.user.last}`;
    }
  },
  methods: {
    openUserModal() {
      this.$emit('open-user-modal', this.user);
    },
    showDeleteModal() {
      this.$emit('show-delete-modal', this.user);
    }
  }
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('pendo-drawer', {
    attrs: {
      "visible": _vm.visible,
      "class-name": "user-side-panel",
      "size": "377px",
      "push": ".pendo-page",
      "close-on-mask-click": false
    },
    on: {
      "closed": function ($event) {
        return _vm.$emit('closed');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "user-side-panel__wrapper"
        }, [_c('div', {
          staticClass: "user-side-panel__header"
        }, [_c('h3', {
          staticClass: "user-side-panel__header__name"
        }, [_vm._v("\n                    " + _vm._s(_vm.userFullName) + "\n                ")]), _vm._v(" "), _c('p', {
          staticClass: "user-side-panel__header__username"
        }, [_vm._v("\n                    " + _vm._s(_vm.user.username) + "\n                ")]), _vm._v(" "), !_vm.isScimEnabled ? _c('div', {
          staticClass: "user-side-panel__header__actions"
        }, [_c('pendo-button', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              trigger: 'hover',
              content: 'Edit',
              boundariesElement: 'viewport'
            },
            expression: "{ trigger: 'hover', content: 'Edit', boundariesElement: 'viewport' }"
          }],
          staticClass: "edit-user hover-styling",
          attrs: {
            "data-cy": "edit-" + _vm.user.username + "-button",
            "icon": "edit",
            "theme": "app",
            "type": "secondary",
            "icon-size": "16"
          },
          on: {
            "click": _vm.openUserModal
          }
        }, [_vm._v("\n                        Edit User\n                    ")]), _vm._v(" "), _c('pendo-button', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              trigger: 'hover',
              content: _vm.userAction,
              boundariesElement: 'viewport'
            },
            expression: "{\n                            trigger: 'hover',\n                            content: userAction,\n                            boundariesElement: 'viewport'\n                        }"
          }],
          attrs: {
            "data-cy": "delete-button",
            "icon": "trash-2",
            "theme": "app",
            "type": "tertiary",
            "icon-size": "16"
          },
          on: {
            "click": _vm.showDeleteModal
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('pendo-drawer-close')], 1)];
      },
      proxy: true
    }, {
      key: "body",
      fn: function () {
        return [_c('user-permission-levels', {
          attrs: {
            "can-select-viewer": _vm.canSelectViewer,
            "show-sharing": _vm.showSharing,
            "show-validate": _vm.showValidate,
            "user": _vm.user,
            "apps": _vm.apps,
            "role-name-map": _vm.roleNameMap,
            "sub-id": _vm.subId
          }
        })];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$b = [];

/* style */
const __vue_inject_styles__$b = function (inject) {
  if (!inject) return;
  inject("data-v-1866b8ad_0", {
    source: ".user-side-panel__wrapper{margin-top:20px;display:grid;grid-template-columns:5fr min-content}.user-side-panel__header{overflow-x:hidden;white-space:nowrap}.user-side-panel__header__name{margin-top:0;margin-bottom:0;overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis}.user-side-panel__header__username{margin-top:0;margin-bottom:20px}.user-side-panel__header__actions{margin-bottom:20px}.user-side-panel__header .edit-user{margin-right:12px}.user-side-panel .pendo-drawer__content{grid-template-rows:[header] auto [body] 1fr!important}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$b = undefined;
/* module identifier */
const __vue_module_identifier__$b = undefined;
/* functional template */
const __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

//
var script$a = {
  name: 'DeleteUserModal',
  components: {
    PendoModal
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    subId: {
      type: [Number, String],
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    storybookMock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    action() {
      return getRemovalAction(this.user);
    },
    confirmRemoveUserLabel() {
      return getRemovalStatement(this.user);
    },
    title() {
      return `${this.confirmRemoveUserLabel}?`;
    }
  },
  methods: {
    isInvitation,
    handleConfirm() {
      return isInvitation(this.user) ? this.revoke(this.user, this.action) : this.deleteUser();
    },
    async deleteUser() {
      if (this.storybookMock) {
        this.$emit('deleted', this.user);
        this.$emit('close');
        return;
      }
      this.loading = true;
      try {
        await removeUser({
          userId: this.user.id,
          subId: this.subId
        });
        PendoNotification({
          type: 'success',
          message: `Successfully removed user ${this.user.username}`
        });
        this.$emit('deleted', this.user);
        this.$emit('close');
      } catch (err) {
        const errMsg = get(err, 'response.data.error', undefined);
        PendoNotification({
          type: 'error',
          message: errMsg && errMsg.includes('org admin') ? `${this.user.username} must be removed as an Organization Admin in order to be removed from all subscriptions.` : `Failed to remove user ${this.user.username}.\n${err}.`
        });
      }
      this.loading = false;
    },
    async revoke(user, action) {
      if (this.storybookMock) {
        this.$emit('deleted', this.user);
        this.$emit('close');
        return;
      }
      try {
        await removeInvite({
          invitationId: user.id,
          subId: this.subId
        });
        PendoNotification({
          type: 'success',
          message: action === 'Remove' ? `The invitation sent to ${user.username} has been removed.` : `The invitation sent to ${user.username} has been revoked.`
        });
        this.$emit('deleted', this.user);
        this.$emit('close');
      } catch (err) {
        PendoNotification({
          type: 'error',
          message: action === 'Remove' ? `Your request failed. Unable to remove ${user.username} at this time.\n${err}` : `Your request failed. Unable to revoke the invitation sent to ${user.username} at this time.\n${err}`
        });
      }
    }
  }
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('pendo-modal', {
    attrs: {
      "height": "auto",
      "type": "confirmation",
      "visible": _vm.visible,
      "title": _vm.title,
      "append-to-body": true,
      "confirm-button-config": {
        'type': 'danger',
        'label': _vm.confirmRemoveUserLabel,
        'theme': 'app',
        loading: _vm.loading,
        'data-cy': 'delete-user-confirm'
      },
      "cancel-button-config": {
        'type': 'secondary',
        'theme': 'app',
        'data-cy': 'delete-user-cancel'
      }
    },
    on: {
      "cancel": function ($event) {
        return _vm.$emit('close');
      },
      "closed": function ($event) {
        return _vm.$emit('closed');
      },
      "confirm": _vm.handleConfirm
    }
  }, [_vm.isInvitation(_vm.user) ? _c('span', [_vm._v("\n        This action will " + _vm._s(_vm.action.toLowerCase()) + " the invitation sent to "), _c('strong', [_vm._v(_vm._s(_vm.user.username))]), _vm._v(", but you can reinvite this user to this subscription any time.\n    ")]) : _c('span', [_vm._v("\n        This action doesn't remove the guides, public reports, and segments created by\n        "), _c('strong', [_vm._v(_vm._s(_vm.user.username))]), _vm._v(", but the user will no longer have access to this subscription to view or edit them.\n    ")])]);
};
var __vue_staticRenderFns__$a = [];

/* style */
const __vue_inject_styles__$a = undefined;
/* scoped */
const __vue_scope_id__$a = undefined;
/* module identifier */
const __vue_module_identifier__$a = undefined;
/* functional template */
const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

//
var script$9 = {
  name: 'FeedbackPermissionsGroup',
  components: {
    PendoForm,
    PendoFormItem,
    PendoMultiselect
  },
  props: {
    activeGroup: {
      type: Object,
      required: false,
      default: () => ({})
    },
    permissionGroups: {
      type: Array,
      required: true
    },
    selectedUser: {
      type: Object,
      required: false,
      default: () => ({})
    },
    subscription: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {},
      rules: [{
        required: true,
        message: 'Feedback permissions are required',
        trigger: ['blur', 'change']
      }]
    };
  },
  computed: {
    feedbackPermissionsEnabled() {
      if (get(this.subscription, 'vendorId', '')) {
        return true;
      }
      if (this.selectedUser) {
        return Boolean(!this.selectedUser.id || this.selectedUser.id && this.selectedUser.vendorUserPermissionId);
      }
      return true;
    },
    cannotConfigureUser() {
      if (get(this.subscription, 'vendorId', '')) {
        return false;
      }
      if (isInvitation(this.selectedUser)) {
        return false;
      }
      if (this.selectedUser) {
        return Boolean(this.selectedUser.id && !this.selectedUser.vendorUserId);
      }
      return false;
    },
    permissionGroupMap() {
      return keyBy(this.permissionGroups, 'id');
    }
  },
  watch: {
    activeGroup: {
      deep: true,
      handler(newActiveGroup, oldActiveGroup) {
        if (newActiveGroup.prop !== oldActiveGroup.prop) {
          this.populateForm();
        }
      }
    },
    form: {
      deep: true,
      handler() {
        if (this.feedbackPermissionsEnabled) {
          this.$refs.feedbackPermissionsSelection.validate(isValid => this.handleFormValidation(isValid));
        }
      }
    }
  },
  created() {
    this.populateForm();
  },
  methods: {
    handleFormValidation(isValid) {
      if (isValid) {
        this.$emit('valid', this.form);
      } else {
        this.$emit('invalid', this.form);
      }
    },
    populateForm() {
      if (!isEmpty(this.selectedUser)) {
        this.$set(this.form, 'permissionGroup', this.permissionGroupMap[this.selectedUser.vendorUserPermissionId]);
        return;
      }
      if (!isEmpty(this.activeGroup)) {
        this.$set(this.form, 'permissionGroup', this.permissionGroupMap[this.activeGroup.permissionsConfig.vendorUserPermissionId]);
        return;
      }
      this.$set(this.form, 'permissionGroup', '');
    }
  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "data-cy": "feedback-permissions-block"
    }
  }, [_vm.cannotConfigureUser ? _c('span', [_vm._v("\n        Permissions can't be configured for this user. Please contact your Pendo representative.\n    ")]) : _vm._e(), _vm._v(" "), _vm.feedbackPermissionsEnabled ? [_c('pendo-form', {
    ref: "feedbackPermissionsSelection",
    attrs: {
      "model": _vm.form
    }
  }, [_c('pendo-form-item', {
    staticClass: "permissions-multiselect",
    attrs: {
      "prop": "permissionGroup",
      "full-width": true,
      "rules": _vm.rules
    }
  }, [_c('pendo-multiselect', {
    attrs: {
      "allow-empty": _vm.activeGroup ? false : true,
      "placeholder": "Select Permission Group",
      "label-key": "name",
      "value-key": "id",
      "full-width": true,
      "min-menu-width": 240,
      "options": _vm.permissionGroups
    },
    model: {
      value: _vm.form.permissionGroup,
      callback: function ($$v) {
        _vm.$set(_vm.form, "permissionGroup", $$v);
      },
      expression: "form.permissionGroup"
    }
  })], 1)], 1)] : _vm._e()], 2);
};
var __vue_staticRenderFns__$9 = [];

/* style */
const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-b00329e0_0", {
    source: ".permissions-multiselect{margin-top:8px;margin-bottom:24px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$9 = undefined;
/* module identifier */
const __vue_module_identifier__$9 = undefined;
/* functional template */
const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

//
var script$8 = {
  name: 'TogglePills',
  directives: {
    PendoTooltip
  },
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Array,
      required: true
    },
    enableViewerPermission: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      SELECTION_STATE
    };
  },
  methods: {
    selectOption({
      target
    }, option) {
      const toState = target.checked ? SELECTION_STATE.checked : SELECTION_STATE.unchecked;
      this.$set(option, 'selectionState', toState);
      this.$emit('change', option);
    },
    getOptionTooltipText(option) {
      if (option.id === VOC_VIEWER_ROLE) {
        return 'Viewer is the default role for all users and cannot be unassigned.';
      }
      if (option.name === 'Viewer' && !this.enableViewerPermission) {
        return 'Viewer is the default role for all applications and cannot be unassigned.';
      }
      if (option.isDisabled) {
        if (hasResourceCenterPermissionSet(option)) {
          return `This role cannot be applied to the following: ${option.appsWithoutRC}`;
        }
        return 'Select apps for which you would like to grant a role.';
      }
      if (option.selectionState === SELECTION_STATE.indeterminate) {
        return `This role only applies to: ${option.appNames}`;
      }
    }
  }
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('fieldset', [_vm.label ? _c('legend', [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "option-list"
  }, _vm._l(_vm.options, function (option) {
    return _c('label', {
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip",
        value: {
          content: _vm.getOptionTooltipText(option)
        },
        expression: "{\n                content: getOptionTooltipText(option)\n            }"
      }],
      key: option.id,
      staticClass: "option",
      class: [option.selectionState, option.isDisabled && 'disabled'],
      attrs: {
        "for": option.id,
        "data-cy": option.id + "-option",
        "type": "checkbox"
      },
      on: {
        "mouseenter": function ($event) {
          return _vm.$emit('hover', option.id);
        },
        "mouseleave": function ($event) {
          return _vm.$emit('hover', null);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(option.name))]), _vm._v(" "), _c('input', {
      attrs: {
        "id": option.id,
        "disabled": option.isDisabled,
        "indeterminate": option.selectionState === _vm.SELECTION_STATE.indeterminate,
        "type": "checkbox"
      },
      domProps: {
        "checked": option.selectionState === _vm.SELECTION_STATE.checked
      },
      on: {
        "change": function ($event) {
          return _vm.selectOption($event, option);
        }
      }
    })]);
  }), 0)]);
};
var __vue_staticRenderFns__$8 = [];

/* style */
const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-00b6e22c_0", {
    source: "fieldset[data-v-00b6e22c]{margin-top:23px}legend[data-v-00b6e22c]{user-select:text;border:none}label[data-v-00b6e22c],legend[data-v-00b6e22c]{color:#2a2c35;font-size:14px;font-weight:600;line-height:20px;margin:8px 0}.option-list[data-v-00b6e22c]{display:flex;flex-wrap:wrap}.option-list label[data-v-00b6e22c]{display:flex;align-items:center;justify-content:space-around;user-select:none}.option-list label input[type=checkbox][data-v-00b6e22c]{background:0 0;border:none;display:block;margin:0;outline:0;padding:0;position:absolute;-webkit-appearance:none}.option-list .option[data-v-00b6e22c]{border:1px solid #dadce5;border-radius:3px;box-sizing:border-box;color:#2a2c35;cursor:pointer;line-height:24px;margin:8px 8px 0 0;padding:5px 8px;text-align:center;transition-property:all;transition-duration:.2s;user-select:none}.option-list .option .option-icon[data-v-00b6e22c]{margin-right:8px}.option-list .option span[data-v-00b6e22c]{font-size:12px;font-weight:600}.option-list .option[data-v-00b6e22c]:focus,.option-list .option[data-v-00b6e22c]:focus-within,.option-list .option[data-v-00b6e22c]:hover{border:1px solid #128297}.option-list .option.checked[data-v-00b6e22c]{background-color:#128297;border:1px solid #128297;color:#fff}.option-list .option.disabled[data-v-00b6e22c]{background-color:#f8f8f9;cursor:not-allowed}.option-list .option.disabled.checked[data-v-00b6e22c]{color:#fff;background-color:#016479;opacity:.5;border:1px solid #dadce5}.option-list .option.indeterminate[data-v-00b6e22c]{background-color:#fdefd5;border:1px solid #dadce5;color:#2a2c35}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$8 = "data-v-00b6e22c";
/* module identifier */
const __vue_module_identifier__$8 = undefined;
/* functional template */
const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

//
var script$7 = {
  name: 'AppSelector',
  components: {
    AppRolesList: __vue_component__$e,
    PendoInput,
    PendoButton,
    PendoLoadingIndicator,
    PendoIcon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subheader: {
      type: String,
      default: ''
    },
    itemList: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      default: () => {}
    },
    disableSelectAll: {
      type: Boolean,
      default: false
    },
    indeterminateRoles: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localItemList: [],
      searchTerm: '',
      loading: true
    };
  },
  computed: {
    onlyOneApp() {
      return this.localItemList.length === 1;
    },
    reorderedDisplayList() {
      if (this.searchTerm.length > 0) {
        return this.orderListBySearchTerm(this.localItemList, this.searchTerm);
      }
      return this.localItemList;
    },
    selectedItems() {
      return this.localItemList.filter(({
        checked
      }) => checked);
    },
    selectButtonText() {
      if (this.selectedItems.length === this.localItemList.length) {
        return 'Clear';
      }
      return 'Select All';
    }
  },
  watch: {
    itemList: {
      immediate: true,
      handler: 'updateRoleNames'
    },
    selectedItems(newVal) {
      this.$emit('selected', newVal);
    }
  },
  created() {
    this.localItemList = cloneDeep(this.itemList);
    if (this.onlyOneApp || !isEmpty(this.user)) {
      this.localItemList.forEach(item => {
        this.$set(item, 'checked', true);
      });
    } else {
      this.localItemList.forEach(item => {
        this.$set(item, 'checked', false);
      });
    }
    this.loading = false;
  },
  methods: {
    updateRoleNames(newItemList) {
      this.localItemList.forEach((item, index) => {
        this.$set(item, 'roleNames', newItemList[index].roleNames);
      });
    },
    orderListBySearchTerm(list, searchTerm) {
      // sort isn't immutable, so slice creates a shallow copy first
      // shallow keeps the references to the list's objects
      return list.slice().sort((a, b) => {
        if (a.displayName.toLowerCase().indexOf(searchTerm.toLowerCase()) < b.displayName.toLowerCase().indexOf(searchTerm.toLowerCase())) {
          return 1;
        }
        if (b.displayName.toLowerCase().indexOf(searchTerm.toLowerCase()) < a.displayName.toLowerCase().indexOf(searchTerm.toLowerCase())) {
          return -1;
        }
        return 0;
      });
    },
    toggleAllChecked() {
      const allChecked = this.localItemList.every(({
        checked
      }) => checked);
      this.localItemList.forEach(item => {
        this.$set(item, 'checked', !allChecked);
      });
    },
    handleChange({
      application: {
        id: appId
      }
    }) {
      const matchingApp = this.localItemList.find(({
        id
      }) => appId === id);
      if (!matchingApp) {
        return;
      }
      this.$set(matchingApp, 'checked', !matchingApp.checked);
    }
  }
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    attrs: {
      "data-cy": "app-selector"
    }
  }, [_vm.loading ? _c('div', {
    staticClass: "loading-apps",
    attrs: {
      "data-cy": "apps-loader"
    }
  }, [_c('pendo-loading-indicator', {
    attrs: {
      "loading": true,
      "size": "large",
      "text": "Loading...",
      "text-class": "loading-apps-text"
    }
  })], 1) : _c('fieldset', [_c('header', [_c('div', {
    staticClass: "section-header",
    attrs: {
      "data-cy": "app-selector-header"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    " + _vm._s(_vm.title) + "\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "subheader"
  }, [_vm._v(_vm._s(_vm.subheader))])]), _vm._v(" "), !_vm.onlyOneApp ? _c('div', [_c('pendo-input', {
    staticClass: "search-input search-input--full-width",
    attrs: {
      "data-cy": "selector-search",
      "placeholder": "Search Applications"
    },
    scopedSlots: _vm._u([{
      key: "prefix",
      fn: function () {
        return [_c('pendo-icon', {
          attrs: {
            "type": "search",
            "stroke": "#2a2c35",
            "size": "16"
          }
        })];
      },
      proxy: true
    }], null, false, 2469770501),
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), _vm._v(" "), _c('pendo-button', {
    attrs: {
      "label": _vm.selectButtonText,
      "data-cy": "selector-select-all",
      "type": "link",
      "disabled": _vm.disableSelectAll
    },
    on: {
      "click": _vm.toggleAllChecked
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('app-roles-list', {
    attrs: {
      "apps": _vm.reorderedDisplayList,
      "disable-interaction": _vm.onlyOneApp,
      "indeterminate-roles": _vm.indeterminateRoles
    },
    on: {
      "change": _vm.handleChange
    }
  })], 1)]);
};
var __vue_staticRenderFns__$7 = [];

/* style */
const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-4c6eaeca_0", {
    source: ".section-header[data-v-4c6eaeca]{user-select:text;color:#2a2c35;font-size:16px;font-weight:600;line-height:120%;margin-bottom:16px}.section-header .subheader[data-v-4c6eaeca]{color:#6a6c75;font-size:14px;font-weight:400}.loading-apps[data-v-4c6eaeca]{margin-top:156px}.search-input--full-width[data-v-4c6eaeca]{max-width:100%}.loading-apps-text[data-v-4c6eaeca]{color:#2a2c35;line-height:1em;font-weight:400;font-size:24px;margin-top:16px}fieldset[data-v-4c6eaeca]{min-width:0;padding:0;margin:0;border:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$7 = "data-v-4c6eaeca";
/* module identifier */
const __vue_module_identifier__$7 = undefined;
/* functional template */
const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

//
var script$6 = {
  name: 'AppPermissionsContainer',
  components: {
    AppSelector: __vue_component__$7,
    PendoAlert,
    PendoIcon,
    PendoLoadingIndicator,
    TogglePills: __vue_component__$8
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    activeGroup: {
      type: Object,
      default: () => {}
    },
    apps: {
      type: Array,
      default: () => []
    },
    productType: {
      type: String,
      required: true
    },
    roles: {
      type: Array,
      required: true
    },
    roleNameMap: {
      type: Object,
      required: true
    },
    subscriptionConfig: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selectedApps: [],
      modalBodyScrollY: 0,
      focusedRoleId: undefined,
      userAppRolesLoading: false,
      applicationPermissionsMap: {},
      customRolesMap: {},
      predefinedRoles: [],
      customRoles: []
    };
  },
  computed: {
    emptyStateText() {
      if (this.canSelectViewer) {
        return 'Select which apps to grant user access to. You must grant a minimum of Viewer-level access for any selected app.';
      }
      return 'Select an application on the left. All applications require "Viewer" permissions.';
    },
    isSingleApp() {
      return this.apps.length && this.apps.length === 1;
    },
    canSelectViewer() {
      return get(this.subscriptionConfig, 'enableViewerPermission', false);
    },
    hasCustomRoles() {
      const customRolesEnabled = get(this.subscriptionConfig, 'useAdoptParityCustomRolesEnabled', false) || get(this.subscriptionConfig, 'enableCustomUserRoles', false);
      return customRolesEnabled && this.customRoles.length > 0;
    },
    isAdopt() {
      return this.productType === 'Adopt';
    },
    focusedRoleDescriptionData() {
      switch (this.focusedRoleId) {
        case 'sunrise_default':
        case 'predefined_1':
        case 'predefined_sub_6':
        case 'predefined_sub_7':
          return ROLE_MAP[this.focusedRoleId];
        case 'predefined_2':
        case 'predefined_3':
        case 'predefined_4':
        case 'predefined_5':
        case 'predefined_6':
        case 'predefined_7':
          return this.isAdopt ? ROLE_MAP[this.focusedRoleId] : NPS_ROLE_MAP[this.focusedRoleId];
        default:
          return this.customRolesMap[this.focusedRoleId] || ROLE_MAP.default;
      }
    },
    roleTitle() {
      return this.focusedRoleDescriptionData.name;
    },
    roleDescription() {
      const hasNPSTriageFlag = get(this.subscriptionConfig, 'enableNPSThemesTriage', false) && get(this.subscriptionConfig, 'hasNPSThemesPermissions', false);
      const {
        description
      } = this.focusedRoleDescriptionData;
      if (Array.isArray(description) && !hasNPSTriageFlag) {
        return description.filter(item => !item.includes('Triage NPS Themes'));
      }
      return description;
    },
    roleFootnote() {
      return this.focusedRoleDescriptionData.footnote;
    },
    roleChooserSubheader() {
      const singleAppString = "Select roles below to add to or remove from this user's permissions.";
      const multiAppString = 'Select roles below to add to or remove from the selected applications on the left.';
      const viewerExplanation = this.canSelectViewer ? ' The Viewer role grants view access to the entire app data. All other roles come with Viewer access included.' : '';
      if (this.isSingleApp) {
        return `${singleAppString}${viewerExplanation}`;
      }
      return `${multiAppString}${viewerExplanation}`;
    },
    rolesInConflictState() {
      const predefinedConflict = this.predefinedRoles.find(role => role.selectionState === 'indeterminate');
      const customConflict = this.customRoles.find(role => role.selectionState === 'indeterminate');
      return !!predefinedConflict || !!customConflict;
    },
    indeterminateRoles() {
      return [...this.predefinedRoles, ...this.customRoles].reduce((array, role) => {
        if (role.selectionState === 'indeterminate') {
          array.push(role);
        }
        return array;
      }, []);
    },
    applicationPermissionsList() {
      return this.apps.map(({
        id,
        platform,
        displayName,
        applicationFlags
      }) => ({
        id,
        platform,
        displayName,
        resourceCenterAccess: !this.isAEU || applicationFlags.resourceCenterAccess,
        roleNames: buildRoleListDisplayName(this.applicationPermissionsMap[id], this.roleNameMap)
      }));
    },
    isAEU() {
      return get(this.subscriptionConfig, 'isAEU', false);
    },
    appsWithRCRoles() {
      return !this.isAEU ? this.apps : this.apps.filter(app => get(app, 'applicationFlags.resourceCenterAccess', false));
    },
    hasResourceCenter() {
      return this.appsWithRCRoles.length || get(this.subscriptionConfig, 'hasResourceCenterAccess', false);
    },
    disableRCRoles() {
      if (get(this.subscriptionConfig, 'hasResourceCenterAccess', false)) {
        return false;
      }
      return this.isAEU && this.selectedApps.some(app => !get(app, 'resourceCenterAccess', false));
    },
    selectAppsSubheader() {
      if (this.canSelectViewer) {
        return 'Select applications from your list below to add roles.';
      }
      return 'Select applications from your list below to add roles. A user must be at least a Viewer for every application.';
    }
  },
  watch: {
    applicationPermissionsMap: {
      deep: true,
      handler(newApplicationPermissionsMap) {
        if (!isEmpty(this.activeGroup) || this.canSelectViewer) {
          const updatedPredefinedRoles = this.updateRolesListState(this.predefinedRoles);
          const updatedCustomRoles = this.updateRolesListState(this.customRoles);
          this.$set(this, 'predefinedRoles', updatedPredefinedRoles);
          this.$set(this, 'customRoles', updatedCustomRoles);
        }
        this.$emit('change', newApplicationPermissionsMap);
      }
    }
  },
  mounted() {
    const modalBodyElement = document.getElementsByClassName('pendo-drawer__body')[0];
    if (modalBodyElement) {
      modalBodyElement.addEventListener('scroll', () => {
        this.modalBodyScrollY = modalBodyElement.scrollTop;
      });
    }
  },
  created() {
    this.userAppRolesLoading = true;
    this.filterRoles();
    this.sortPredefinedRolesList();
    this.sortCustomRolesList();
    this.customRolesMap = buildRoleMapBy(this.customRoles);
    if (!isEmpty(this.activeGroup)) {
      this.applicationPermissionsMap = buildApplicationPermissionsMap(this.activeGroup.permissionsConfig, this.apps, this.canSelectViewer);
    } else {
      this.applicationPermissionsMap = buildApplicationPermissionsMap(this.user, this.apps, this.canSelectViewer);
    }
    if (this.isSingleApp) {
      this.handleSelectedApps(this.applicationPermissionsList);
    }
    this.userAppRolesLoading = false;
    this.$emit('loaded-app-perms');
  },
  methods: {
    handleSelectedApps(selectedApps) {
      this.$set(this, 'selectedApps', selectedApps);
      const updatedPredefinedRoles = this.updateRolesListState(this.predefinedRoles);
      const updatedCustomRoles = this.updateRolesListState(this.customRoles);
      this.$set(this, 'predefinedRoles', updatedPredefinedRoles);
      this.$set(this, 'customRoles', updatedCustomRoles);
    },
    handleRoleSelectionChange({
      selectionState,
      id: roleId
    }) {
      if (selectionState === SELECTION_STATE.checked) {
        this.selectedApps.forEach(({
          id: appId
        }) => {
          const currentRoles = cloneDeep(this.applicationPermissionsMap[appId]);
          if (!currentRoles.length && this.canSelectViewer) {
            currentRoles.push(DEFAULT_APPLICATION_ROLE);
          }
          if (currentRoles.indexOf(roleId) < 0) {
            currentRoles.push(roleId);
          }
          this.applicationPermissionsMap[appId] = currentRoles;
        });
        return;
      }
      this.selectedApps.forEach(({
        id: appId
      }) => {
        if (roleId === DEFAULT_APPLICATION_ROLE && this.canSelectViewer) {
          this.applicationPermissionsMap[appId] = [];
        } else {
          const index = this.applicationPermissionsMap[appId].indexOf(roleId);
          this.applicationPermissionsMap[appId].splice(index, 1);
        }
      });
    },
    handleFocusedRoleChange(roleId) {
      this.focusedRoleId = roleId;
    },
    updateRolesListState(rolesList) {
      return rolesList.map(role => ({
        ...role,
        isDisabled: role.id === DEFAULT_APPLICATION_ROLE && !this.canSelectViewer || this.selectedApps.length === 0 || this.disableRCRoles && hasResourceCenterPermissionSet(role),
        ...getRoleSelectionStateAndAppNames(this.selectedApps, role.id, this.applicationPermissionsMap, this.canSelectViewer)
      }));
    },
    filterRoles() {
      this.roles.forEach(role => {
        const {
          type,
          name
        } = role;
        const includeResourceCenter = this.hasResourceCenter || !hasResourceCenterPermissionSet(role);
        if (!includeResourceCenter) {
          return;
        }
        if (type === 'predefined') {
          this.predefinedRoles.push(role);
        }
        if (type === 'custom' && Boolean(name)) {
          this.customRoles.push(role);
        }
      });
    },
    sortPredefinedRolesList() {
      const index = this.predefinedRoles.findIndex(role => role.id === 'predefined_1');
      const viewer = this.predefinedRoles[index];
      this.predefinedRoles.splice(index, 1);
      this.predefinedRoles.sort(sortByName);
      this.predefinedRoles.unshift(viewer);
    },
    sortCustomRolesList() {
      this.customRoles.sort(sortByName);
    }
  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_vm.userAppRolesLoading ? _c('div', {
    staticClass: "loading",
    attrs: {
      "data-cy": "loader"
    }
  }, [_c('pendo-loading-indicator', {
    attrs: {
      "size": "large",
      "text": "Loading...",
      "text-class": "loading-text"
    }
  })], 1) : _c('div', {
    staticClass: "app-level-roles"
  }, [!_vm.isSingleApp ? _c('section', {
    staticClass: "half"
  }, [_c('app-selector', {
    attrs: {
      "title": "Select Applications",
      "subheader": _vm.selectAppsSubheader,
      "item-list": _vm.applicationPermissionsList,
      "user": _vm.user,
      "indeterminate-roles": _vm.indeterminateRoles
    },
    on: {
      "selected": _vm.handleSelectedApps
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "right-panel",
      "mode": "out-in"
    }
  }, [!_vm.isSingleApp && _vm.selectedApps.length === 0 ? _c('section', {
    key: "empty",
    staticClass: "half"
  }, [_c('div', {
    staticClass: "empty-state"
  }, [_c('pendo-icon', {
    staticClass: "empty-state__icon",
    attrs: {
      "type": "arrow-left-circle",
      "size": "39",
      "stroke": "#2A2C35",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "empty-state__text"
  }, [_vm._v(_vm._s(_vm.emptyStateText))])], 1)]) : _c('section', {
    key: "role-chooser",
    staticClass: "role-list-section",
    class: {
      'half': !_vm.isSingleApp,
      'role-chooser': _vm.isSingleApp
    },
    attrs: {
      "data-cy": "role-chooser"
    }
  }, [_c('div', {
    staticClass: "role-list"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_vm._v("\n                            Apply a Role or Multiple Roles\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "section-subheader"
  }, [_vm._v(_vm._s(_vm.roleChooserSubheader))])]), _vm._v(" "), _c('toggle-pills', {
    attrs: {
      "label": "Default Roles",
      "options": _vm.predefinedRoles,
      "enable-viewer-permission": _vm.canSelectViewer,
      "allow-multiple-selections": ""
    },
    on: {
      "change": _vm.handleRoleSelectionChange,
      "hover": _vm.handleFocusedRoleChange
    }
  }), _vm._v(" "), _vm.hasCustomRoles ? _c('toggle-pills', {
    attrs: {
      "label": "Custom Roles",
      "options": _vm.customRoles,
      "allow-multiple-selections": ""
    },
    on: {
      "change": _vm.handleRoleSelectionChange,
      "hover": _vm.handleFocusedRoleChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: {
      'divider-half': !_vm.isSingleApp,
      'divider': _vm.isSingleApp
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "role-description"
    }
  }, [_vm.rolesInConflictState ? _c('pendo-alert', {
    attrs: {
      "data-cy": "conflict-roles-warning",
      "type": "warning",
      "title": "Multiple applications are selected with different assigned roles."
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "role-description__title"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.roleTitle) + "\n                    ")]), _vm._v(" "), _vm.focusedRoleId && Array.isArray(_vm.roleDescription) ? _c('ul', {
    attrs: {
      "id": "role-description__bullets"
    }
  }, _vm._l(_vm.roleDescription, function (bullet) {
    return _c('li', {
      key: bullet
    }, [_vm._v("\n                            " + _vm._s(bullet) + "\n                        ")]);
  }), 0) : _c('p', {
    attrs: {
      "id": "role-description__desc"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.roleDescription) + "\n                    ")]), _vm._v(" "), _vm.roleFootnote ? _c('p', [_vm._v("\n                        " + _vm._s(_vm.roleFootnote) + "\n                    ")]) : _vm._e()], 1)])])], 1)]);
};
var __vue_staticRenderFns__$6 = [];

/* style */
const __vue_inject_styles__$6 = function (inject) {
  if (!inject) return;
  inject("data-v-9568e924_0", {
    source: ".app-level-roles[data-v-9568e924]{display:flex;flex-direction:row}.half[data-v-9568e924]{height:700px;width:50%;padding:20px;overflow-x:hidden;overflow-y:hidden}.half[data-v-9568e924]:first-of-type{border-right:1px solid #dadce5}.half fieldset[data-v-9568e924]{padding:0;border:0}.right-panel-enter[data-v-9568e924],.right-panel-leave-active[data-v-9568e924]{transition:opacity .3s ease}.right-panel-enter[data-v-9568e924],.right-panel-leave-to[data-v-9568e924]{opacity:0}.header-text[data-v-9568e924]{user-select:text;color:#2a2c35;font-size:16px;font-weight:600;line-height:120%;margin-bottom:16px}.header-text .section-subheader[data-v-9568e924]{color:#6a6c75;font-size:14px;font-weight:400}.loading[data-v-9568e924]{margin-top:156px}.loading-text[data-v-9568e924]{color:#2a2c35;line-height:1em;font-weight:400;font-size:24px;margin-top:16px}.role-chooser[data-v-9568e924]{padding:20px;overflow-x:hidden;overflow-y:hidden}.role-list-section[data-v-9568e924]{padding:0;position:relative}.role-list[data-v-9568e924]{max-height:400px;overflow-y:auto;padding:20px}.empty-state[data-v-9568e924]{height:379px;display:flex;flex-direction:column;justify-content:center;align-items:center}.empty-state__text[data-v-9568e924]{color:#2a2c35;font-weight:600;font-size:14px;line-height:18.2px;margin-top:16px;text-align:center}.divider[data-v-9568e924],.divider-half[data-v-9568e924]{position:absolute;width:45%;background-color:#fff}.divider-half[data-v-9568e924]:after,.divider-half[data-v-9568e924]:before,.divider[data-v-9568e924]:after,.divider[data-v-9568e924]:before{content:\"\";position:absolute;padding-bottom:3%;border-top:1px solid #dadce5;background:#fff;height:12px}.divider-half[data-v-9568e924]:before,.divider[data-v-9568e924]:before{width:18%;transform-origin:100% 100%;transform:skewX(45deg);border-right:2px solid #dadce5;margin-right:-2px}.divider-half[data-v-9568e924]:after,.divider[data-v-9568e924]:after{width:207%;left:18%;transform-origin:0 100%;transform:skewX(-45deg);border-left:2px solid #dadce5;margin-left:-2px}.divider-half[data-v-9568e924]:after,.divider-half[data-v-9568e924]:before{top:-10px}.conflict-state[data-v-9568e924]{min-height:217px;padding:20px}#role-description[data-v-9568e924]{user-select:text;min-height:217px;overflow-y:auto;padding-right:20px;padding-left:20px;padding-top:20px}#role-description__title[data-v-9568e924]{margin-top:8px;font-weight:600;font-size:14px;line-height:20px;margin-bottom:8px}#role-description__title_icon[data-v-9568e924]{margin-right:12px}#role-description__bullets[data-v-9568e924]{font-size:14px;line-height:20px;padding-left:15px}#role-description__desc[data-v-9568e924]{font-size:14px;line-height:20px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$6 = "data-v-9568e924";
/* module identifier */
const __vue_module_identifier__$6 = undefined;
/* functional template */
const __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

//
var script$5 = {
  name: 'SharingPermissions',
  components: {
    PendoToggle
  },
  directives: {
    PendoTooltip
  },
  props: {
    userPerms: {
      type: Array,
      required: true
    }
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "sharing-permissions"
  }, [_c('p', {
    staticClass: "section-header__permissions-option"
  }, [_vm._v("\n        Segments & Reports\n    ")]), _vm._v(" "), _c('section', {
    staticClass: "permissions-section__toggle"
  }, _vm._l(_vm.userPerms, function (option) {
    return _c('div', {
      key: option.id,
      staticClass: "sharing-permissions-option"
    }, [_c('div', [_c('div', [_vm._v(_vm._s(option.label))]), _vm._v(" "), option.helperText ? _c('div', {
      staticClass: "helper-text"
    }, [_vm._v("\n                    " + _vm._s(option.helperText) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('pendo-toggle', {
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip",
        value: option.disabled && option.tooltip,
        expression: "option.disabled && option.tooltip"
      }],
      attrs: {
        "value": option.checked || false,
        "data-cy": "secondary-option-" + option.id
      },
      on: {
        "change": function ($event) {
          return _vm.$emit('change', option);
        }
      }
    })], 1);
  }), 0)]);
};
var __vue_staticRenderFns__$5 = [];

/* style */
const __vue_inject_styles__$5 = function (inject) {
  if (!inject) return;
  inject("data-v-11b3ba3b_0", {
    source: ".sharing-permissions-option[data-v-11b3ba3b]{display:flex;justify-content:space-between;padding:14px 7px 14px 0}.sharing-permissions-option[data-v-11b3ba3b]:not(:last-child){border-bottom:1px solid #dadce5}.sharing-permissions-option .helper-text[data-v-11b3ba3b]{margin-top:8px;color:#6a6c75;font-size:12px;line-height:14px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$5 = "data-v-11b3ba3b";
/* module identifier */
const __vue_module_identifier__$5 = undefined;
/* functional template */
const __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

//
var script$4 = {
  name: 'ValidatePermissions',
  components: {
    TogglePills: __vue_component__$8
  },
  directives: {
    PendoTooltip
  },
  props: {
    userPerms: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      focusedRoleId: undefined
    };
  },
  computed: {
    focusedRoleDescriptionData() {
      return ROLE_MAP[this.focusedRoleId] || ROLE_MAP.sunrise_default;
    },
    roleTitle() {
      return this.focusedRoleDescriptionData.name;
    },
    roleDescription() {
      return this.focusedRoleDescriptionData.description;
    }
  },
  methods: {
    handleFocusedRoleChange(roleId) {
      this.focusedRoleId = roleId;
    }
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "validate-permissions"
  }, [_c('p', {
    staticClass: "section-header__permissions-option"
  }, [_vm._v("\n        Discover\n    ")]), _vm._v(" "), _c('section', {
    staticClass: "role-list"
  }, [_vm._m(0), _vm._v(" "), _c('toggle-pills', {
    attrs: {
      "label": "Default Roles",
      "options": _vm.userPerms,
      "allow-multiple-selections": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change', $event);
      },
      "hover": _vm.handleFocusedRoleChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "role-description"
  }, [_c('p', {
    staticClass: "role-description__title"
  }, [_vm._v("\n            " + _vm._s(_vm.roleTitle) + "\n        ")]), _vm._v(" "), _vm.focusedRoleId && Array.isArray(_vm.roleDescription) ? _c('ul', {
    staticClass: "role-description__bullets"
  }, _vm._l(_vm.roleDescription, function (bullet) {
    return _c('li', {
      key: bullet
    }, [_vm._v("\n                " + _vm._s(bullet) + "\n            ")]);
  }), 0) : _c('p', {
    staticClass: "role-description__desc"
  }, [_vm._v("\n            " + _vm._s(_vm.roleDescription) + "\n        ")])])]);
};
var __vue_staticRenderFns__$4 = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "tertiary-header"
  }, [_vm._v("\n                Apply a Role or Multiple Roles\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "tertiary-subheader"
  }, [_vm._v("Select roles below to add to or remove from this user's permissions")])]);
}];

/* style */
const __vue_inject_styles__$4 = function (inject) {
  if (!inject) return;
  inject("data-v-1872b805_0", {
    source: ".role-list[data-v-1872b805]{max-height:360px;overflow-y:auto;padding:20px}.tertiary-header[data-v-1872b805]{font-size:16px;font-weight:600;line-height:2em}.tertiary-subheader[data-v-1872b805]{color:#6a6c75;font-size:14px;font-weight:400}.divider[data-v-1872b805]{position:relative;border-top:1px solid #dadce5}.divider[data-v-1872b805]:after,.divider[data-v-1872b805]:before{content:\"\";position:absolute;border-left:15px solid transparent;border-right:15px solid transparent;left:10%}.divider[data-v-1872b805]:before{border-top:15px solid #dadce5;margin:0 -15px}.divider[data-v-1872b805]:after{border-top:15px solid #fff;margin:-2px -15px 0 -15px}.role-description[data-v-1872b805]{user-select:text;min-height:150px;overflow-y:auto;padding-right:20px;padding-left:20px;padding-top:20px}.role-description__title[data-v-1872b805]{margin-top:8px;font-weight:600;font-size:14px;line-height:20px;margin-bottom:8px}.role-description__bullets[data-v-1872b805]{font-size:14px;line-height:20px;padding-left:15px}.role-description__desc[data-v-1872b805]{font-size:14px;line-height:20px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$4 = "data-v-1872b805";
/* module identifier */
const __vue_module_identifier__$4 = undefined;
/* functional template */
const __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

//
var script$3 = {
  name: 'RoleTypeContainer',
  components: {
    PendoLoadingIndicator,
    PendoRadio,
    PendoRadioGroup,
    PendoToggle,
    AppPermissionsContainer: __vue_component__$6,
    SharingPermissions: __vue_component__$5,
    ValidatePermissions: __vue_component__$4
  },
  directives: {
    PendoTooltip
  },
  props: {
    activeUser: {
      type: Object,
      default: () => ({})
    },
    selectedUser: {
      type: Object,
      default: () => ({})
    },
    activeGroup: {
      type: Object,
      default: () => ({})
    },
    roles: {
      type: Array,
      required: true
    },
    apps: {
      type: Array,
      required: true
    },
    productType: {
      type: String,
      required: true
    },
    roleNameMap: {
      type: Object,
      default: () => ({})
    },
    subscriptionConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: true,
      roleTypeCheckList: [],
      adminPerms: null,
      userPerms: null,
      selectedRoleTypeId: null
    };
  },
  computed: {
    adminOption() {
      return this.roleTypeCheckList.find(({
        id
      }) => id === SUBSCRIPTION_ADMIN_ROLE);
    },
    opsOption() {
      return this.adminOption.secondaryOptions.find(({
        id
      }) => id === OPS_ROLE);
    },
    superOption() {
      return this.adminOption.secondaryOptions.find(({
        id
      }) => id === SUPER_ROLE);
    },
    userOrGroupExists() {
      return !isEmpty(this.selectedUser) || !isEmpty(this.activeGroup);
    },
    showAdminSecondaryOptions() {
      return !isEmpty(this.adminPerms.secondaryOptions);
    },
    showSharing() {
      return !isAdoptSub(this.subscriptionConfig) && this.subscriptionConfig.enableSharingPermission;
    },
    showValidate() {
      return this.subscriptionConfig.isVOC;
    },
    selectedSubRoleIds() {
      const selectedSubRoleIds = [];
      this.roleTypeCheckList.forEach(({
        checked,
        id,
        secondaryOptions,
        validateOptions
      }) => {
        if (checked) {
          selectedSubRoleIds.push(id);
          // only pushing these values if the 'parent' option is checked allows us to
          // persist secondaryOption state when toggling between options
          if (secondaryOptions) {
            secondaryOptions.forEach(option => {
              if (option.checked) {
                selectedSubRoleIds.push(option.id);
              }
            });
          }
        }
        if (validateOptions) {
          validateOptions.forEach(option => {
            if (option.selectionState === 'checked') {
              selectedSubRoleIds.push(option.id);
            }
          });
        }
      });
      return selectedSubRoleIds;
    },
    isNewInvitation() {
      return isEmpty(this.selectedUser) && isEmpty(this.activeGroup);
    }
  },
  watch: {
    activeGroup: {
      deep: true,
      handler(newActiveGroup, oldActiveGroup) {
        if (newActiveGroup.prop !== oldActiveGroup.prop) {
          this.loading = true;
          const {
            adminPermissions,
            userPermissions
          } = this.getInitialRoleOptions();
          this.roleTypeCheckList = cloneDeep([adminPermissions, userPermissions]);
          this.resetCheckedOptions(newActiveGroup.permissionsConfig);
          this.adminPerms = this.roleTypeCheckList.find(({
            id
          }) => id === SUBSCRIPTION_ADMIN_ROLE);
          this.userPerms = this.roleTypeCheckList.find(({
            id
          }) => id === SUBSCRIPTION_USER_ROLE);
          this.loading = false;
        }
      }
    }
  },
  created() {
    const {
      adminPermissions,
      userPermissions
    } = this.getInitialRoleOptions();
    this.roleTypeCheckList = cloneDeep([adminPermissions, userPermissions]);
    if (!isEmpty(this.activeGroup)) {
      this.resetCheckedOptions(this.activeGroup.permissionsConfig);
    } else {
      this.resetCheckedOptions(this.selectedUser);
    }
    this.adminPerms = this.roleTypeCheckList.find(({
      id
    }) => id === SUBSCRIPTION_ADMIN_ROLE);
    this.userPerms = this.roleTypeCheckList.find(({
      id
    }) => id === SUBSCRIPTION_USER_ROLE);
    this.selectedRoleTypeId = this.adminPerms.checked && this.adminPerms.id || this.userPerms.checked && this.userPerms.id;
    this.loading = false;
  },
  methods: {
    // this resets the checked value on all role options based on which roles exist on a given user
    resetCheckedOptions(user) {
      if (this.userOrGroupExists && !user.subscriptionRoles) {
        this.roleTypeCheckList.forEach(role => {
          if (role.validateOptions) {
            role.validateOptions.forEach(option => {
              if (option.id === VOC_CONTRIBUTOR_ROLE) {
                this.$set(option, 'selectionState', 'unchecked');
              }
            });
          }
        });
      }
      if (this.userOrGroupExists) {
        const subscriptionRoleIds = [];
        if (user.subscriptionRoles && user.subscriptionRoles.length > 0) {
          subscriptionRoleIds.push(...user.subscriptionRoles);
        } else if (isAdminOrAbove(user)) {
          subscriptionRoleIds.push(SUBSCRIPTION_ADMIN_ROLE);
        }

        // Manually add Role Ids to the list for
        // each field we are not getting back from the API call
        // - adoptManager is driven by a flag
        if (isAdoptManager(user)) {
          subscriptionRoleIds.push(ADOPT_MANAGER_ROLE);
        }
        // - ops is driven by a flag
        if (isOps(user)) {
          subscriptionRoleIds.push(OPS_ROLE);
        }
        // - super is driven by a role number
        if (isSuper(user)) {
          subscriptionRoleIds.push(SUPER_ROLE);
        }
        // - global access is driven by the `globalAccessExpiresAt` user field.
        if (hasGlobalAccess(user)) {
          subscriptionRoleIds.push(GLOBAL_ACCESS_ROLE);
        }
        // - SUBSCRIPTION_USER_ROLE is the default "user"
        if (!subscriptionRoleIds.find(roleId => roleId === SUBSCRIPTION_ADMIN_ROLE)) {
          subscriptionRoleIds.push(SUBSCRIPTION_USER_ROLE);
        }
        this.roleTypeCheckList.forEach(role => {
          this.$set(role, 'checked', subscriptionRoleIds.includes(role.id));
          if (role.secondaryOptions) {
            role.secondaryOptions.forEach(option => {
              this.$set(option, 'checked', subscriptionRoleIds.includes(option.id));
            });
          }
          if (role.validateOptions) {
            role.validateOptions.forEach(option => {
              this.$set(option, 'selectionState', subscriptionRoleIds.includes(option.id) || option.id === VOC_VIEWER_ROLE ? 'checked' : 'unchecked');
            });
          }
        });
      }
      this.$emit('change-sub-level', this.selectedSubRoleIds);
    },
    isOptionDisabledTooltip(roleOption) {
      if (!roleOption) {
        throw Error();
      }
      const disableChecks = {
        [ADOPT_MANAGER_ROLE]: () => {
          if (isInvitation(this.selectedUser)) {
            return 'User must accept invitation before they can be promoted to Adopt Manager.';
          }
          if (!isSuper(this.activeUser) && !(this.subscriptionConfig.isAdoptPartner && isAdmin(this.activeUser) && isAdoptManager(this.activeUser))) {
            return 'You must be an Adopt Manager to toggle Adopt Manager permissions.';
          }
          if (this.isNewInvitation) {
            return 'Invite new user first, then grant Adopt Manager permissions.';
          }
        },
        [SUPER_ROLE]: () => {
          if (isInvitation(this.selectedUser)) {
            return 'User must accept invitation before they can be promoted to Super.';
          }
          if (!isOps(this.activeUser)) {
            return 'You must be Ops to toggle Super permissions.';
          }
          if (this.opsOption && this.opsOption.checked) {
            return 'User must be Super if Ops is enabled.';
          }
          if (this.isNewInvitation) {
            return 'Invite new user first, then promote to Super.';
          }
        },
        [OPS_ROLE]: () => {
          if (!this.superOption || !this.superOption.checked) {
            return 'User must be Super before they can be Ops';
          }
          if (!isOps(this.activeUser)) {
            return 'You must be Ops to toggle Ops permissions.';
          }
        },
        [GLOBAL_ACCESS_ROLE]: () => {
          return 'Global Access is read-only';
        }
      };
      if (disableChecks[roleOption.id]) {
        return disableChecks[roleOption.id]();
      }
      return false;
    },
    getInitialAdminPermissionOptions() {
      const adminPermissions = {
        id: SUBSCRIPTION_ADMIN_ROLE,
        title: 'Subscription Admin Permissions',
        description: 'Subscription admins have full access to this Subscription. This includes all application settings, guide settings, and full analytics capabilities.',
        secondaryOptions: []
      };
      if (this.subscriptionConfig.isAdoptPartner) {
        adminPermissions.secondaryOptions.push({
          id: ADOPT_MANAGER_ROLE,
          name: 'Adopt Manager'
        });
      }

      // Do not provide super/ops/global access options during Groups permission flow
      if (isEmpty(this.activeGroup)) {
        if (isOps(this.activeUser) || isSuper(this.selectedUser)) {
          adminPermissions.secondaryOptions.push({
            id: SUPER_ROLE,
            name: 'Super Permissions'
          }, {
            id: GLOBAL_ACCESS_ROLE,
            name: 'Global Access'
          });
        }
        if (isOps(this.activeUser) || isOps(this.selectedUser)) {
          adminPermissions.secondaryOptions.push({
            id: OPS_ROLE,
            name: 'Ops Permissions'
          });
        }
      }
      return adminPermissions;
    },
    getInitialUserPermissionOptions() {
      const userPermissions = {
        id: SUBSCRIPTION_USER_ROLE,
        title: 'User Permissions',
        description: "Set a user's subscription sharing permissions and application level roles.",
        secondaryOptions: [],
        validateOptions: []
      };
      if (this.showSharing) {
        userPermissions.secondaryOptions.push(...SHARE_OPTIONS);
      }
      if (this.showValidate) {
        userPermissions.validateOptions.push(...VOC_OPTIONS);
      }
      return userPermissions;
    },
    getInitialRoleOptions() {
      return {
        adminPermissions: this.getInitialAdminPermissionOptions(),
        userPermissions: this.getInitialUserPermissionOptions()
      };
    },
    handleRoleChange({
      id
    }) {
      this.roleTypeCheckList.forEach(role => {
        this.$set(role, 'checked', role.id === id);
        this.$emit('role-selected');
      });
      this.selectedRoleTypeId = id;
      this.$emit('change-sub-level', this.selectedSubRoleIds);
    },
    handleAppLevelChange(applicationPermissionsMap) {
      this.$emit('change-app-level', applicationPermissionsMap);
    },
    handleSecondaryOptionChange(option) {
      this.$set(option, 'checked', !option.checked);
      this.$emit('change-sub-level', this.selectedSubRoleIds);
    },
    handleValidateOptionChange(option) {
      const flipOther = roleId => {
        this.userPerms.validateOptions.filter(role => role.id === roleId).forEach(role => {
          role.selectionState = 'unchecked';
        });
      };
      if (option.id === VOC_MANAGER_ROLE && option.selectionState === 'checked') {
        flipOther(VOC_CONTRIBUTOR_ROLE);
      }
      if (option.id === VOC_CONTRIBUTOR_ROLE && option.selectionState === 'checked') {
        flipOther(VOC_MANAGER_ROLE);
      }
      this.$set(option, 'checked', option.selectionState === 'checked');
      this.$emit('change-sub-level', this.selectedSubRoleIds);
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "role-type-container"
  }, [_vm.loading ? _c('div', {
    staticClass: "loading",
    attrs: {
      "data-cy": "role-loader"
    }
  }, [_c('pendo-loading-indicator', {
    attrs: {
      "size": "large",
      "text": "Loading...",
      "text-class": "loading-text"
    }
  })], 1) : _c('section', [_c('pendo-radio-group', {
    attrs: {
      "value": _vm.selectedRoleTypeId
    }
  }, [_c('div', {
    staticClass: "role-type__wrapper"
  }, [_c('label', {
    staticClass: "role-type",
    attrs: {
      "data-cy": "role-type-" + _vm.adminPerms.id,
      "for": _vm.adminPerms.id
    },
    on: {
      "click": function ($event) {
        return _vm.handleRoleChange(_vm.adminPerms);
      }
    }
  }, [_c('pendo-radio', {
    attrs: {
      "id": _vm.adminPerms.id,
      "data-cy": "role-type-radio-" + _vm.adminPerms.id,
      "name": "role-type-item",
      "value": _vm.adminPerms.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "role-type-info"
  }, [_c('div', {
    staticClass: "role-type-info__title"
  }, [_vm._v("\n                            " + _vm._s(_vm.adminPerms.title) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "role-type-info__description"
  }, [_vm._v("\n                            " + _vm._s(_vm.adminPerms.description) + "\n                        ")])])], 1), _vm._v(" "), _vm.adminPerms.checked && _vm.showAdminSecondaryOptions ? _c('div', [_c('p', {
    staticClass: "section-header__permissions-option"
  }, [_vm._v("\n                        Pendo Internal Permissions\n                    ")]), _vm._v(" "), _c('section', {
    staticClass: "permissions-section__toggle"
  }, _vm._l(_vm.adminPerms.secondaryOptions, function (option) {
    return _c('span', {
      key: option.id,
      staticClass: "admin-permissions-option"
    }, [_c('pendo-toggle', {
      directives: [{
        name: "pendo-tooltip",
        rawName: "v-pendo-tooltip.top-end",
        value: _vm.isOptionDisabledTooltip(option),
        expression: "isOptionDisabledTooltip(option)",
        modifiers: {
          "top-end": true
        }
      }],
      attrs: {
        "value": option.checked || false,
        "label": option.name,
        "disabled": !!_vm.isOptionDisabledTooltip(option),
        "label-position": "left",
        "data-cy": "secondary-option-" + option.id
      },
      on: {
        "change": function ($event) {
          return _vm.handleSecondaryOptionChange(option);
        }
      }
    })], 1);
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "role-type__wrapper"
  }, [_c('label', {
    staticClass: "role-type",
    attrs: {
      "data-cy": "role-type-" + _vm.userPerms.id,
      "for": _vm.userPerms.id
    },
    on: {
      "click": function ($event) {
        return _vm.handleRoleChange(_vm.userPerms);
      }
    }
  }, [_c('pendo-radio', {
    attrs: {
      "id": _vm.userPerms.id,
      "data-cy": "role-type-radio-" + _vm.userPerms.id,
      "name": "role-type-item",
      "value": _vm.userPerms.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "role-type-info"
  }, [_c('div', {
    staticClass: "role-type-info__title"
  }, [_vm._v("\n                            " + _vm._s(_vm.userPerms.title) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "role-type-info__description"
  }, [_vm._v("\n                            " + _vm._s(_vm.userPerms.description) + "\n                        ")])])], 1), _vm._v(" "), _vm.userPerms.checked ? _c('div', [_vm.showSharing ? _c('sharing-permissions', {
    attrs: {
      "user-perms": _vm.userPerms.secondaryOptions
    },
    on: {
      "change": _vm.handleSecondaryOptionChange
    }
  }) : _vm._e(), _vm._v(" "), _vm.showValidate ? _c('validate-permissions', {
    attrs: {
      "user-perms": _vm.userPerms.validateOptions
    },
    on: {
      "change": _vm.handleValidateOptionChange
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "section-header__permissions-option"
  }, [_vm._v("\n                        App-Level Roles\n                    ")]), _vm._v(" "), _c('app-permissions-container', {
    attrs: {
      "user": _vm.selectedUser,
      "active-group": _vm.activeGroup,
      "apps": _vm.apps,
      "roles": _vm.roles,
      "product-type": _vm.productType,
      "role-name-map": _vm.roleNameMap,
      "subscription-config": _vm.subscriptionConfig
    },
    on: {
      "change": _vm.handleAppLevelChange,
      "loaded-app-perms": function ($event) {
        _vm.loadingAppRoles = false;
      }
    }
  })], 1) : _vm._e()])])], 1)]);
};
var __vue_staticRenderFns__$3 = [];

/* style */
const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-54e6e22b_0", {
    source: "label[data-v-54e6e22b]{display:block;user-select:none}.loading[data-v-54e6e22b]{margin:56px}.loading-text[data-v-54e6e22b]{color:#2a2c35;line-height:1em;font-weight:400;font-size:24px;margin-top:16px}.role-type[data-v-54e6e22b]{display:flex;padding:18px;cursor:pointer}.role-type__wrapper[data-v-54e6e22b]{border:1px solid #dadce5;border-radius:3px;margin-bottom:12px}.role-type-info[data-v-54e6e22b]{margin-left:9px}.role-type-info__title[data-v-54e6e22b]{font-size:16px;color:#2a2c35;margin-bottom:5px;font-weight:600}.role-type-info__description[data-v-54e6e22b]{font-size:14px;font-weight:400;color:#6a6c75;line-height:130%}.admin-permissions-option[data-v-54e6e22b]{display:inline-block;padding:12px 0;width:100%}.admin-permissions-option[data-v-54e6e22b]:not(:last-child){border-bottom:1px solid #dadce5}.admin-permissions-option .pendo-toggle.is-inline-label[data-v-54e6e22b]{display:flex;justify-content:space-between}fieldset[data-v-54e6e22b]{min-width:0;padding:0;margin:0;border:0}",
    map: undefined,
    media: undefined
  }), inject("data-v-54e6e22b_1", {
    source: ".role-type-container .section-header__permissions-option{user-select:text;text-transform:uppercase;color:#6a6c75;background-color:#f4f4f7;font-weight:700;font-size:12px;line-height:2.3;margin-top:12px;margin-bottom:0;padding-left:24px;letter-spacing:.1em;border-top:1px solid #dadce5;border-bottom:1px solid #dadce5}.role-type-container .permissions-section__toggle{user-select:text;margin:0 22px 12px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$3 = "data-v-54e6e22b";
/* module identifier */
const __vue_module_identifier__$3 = undefined;
/* functional template */
const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

//
const EMPTY_FORM = Object.freeze({
  first: '',
  last: '',
  username: ''
});
var script$2 = {
  name: 'UserDetails',
  components: {
    PendoForm,
    PendoFormItem,
    PendoInput
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    userList: {
      type: Array,
      default: () => []
    },
    isScimEnabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: cloneDeep(EMPTY_FORM),
      hasAllRequiredFields: false
    };
  },
  computed: {
    rules() {
      let isFirstRequired = isEmpty(this.user) || this.user.first;
      let isLastRequired = isEmpty(this.user) || this.user.last;
      if (this.isScimEnabled) {
        isFirstRequired = false;
        isLastRequired = false;
      }
      return {
        first: [{
          required: isFirstRequired,
          message: 'First name is required',
          trigger: ['blur', 'change']
        }, {
          validator: this.nameValidator('First name'),
          trigger: ['blur']
        }],
        last: [{
          required: isLastRequired,
          message: 'Last name is required',
          trigger: ['blur', 'change']
        }, {
          validator: this.nameValidator('Last name'),
          trigger: ['blur']
        }],
        username: [{
          validator: this.validateUsername,
          trigger: ['blur', 'change']
        }, {
          required: isEmpty(this.user),
          message: 'Email address is required',
          trigger: ['blur', 'change']
        }, {
          type: 'email',
          message: 'Please input a valid email address',
          trigger: ['blur']
        }]
      };
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        if (this.hasAllRequiredFields) {
          this.callValidate();
        } else {
          this.updateHasAllRequiredFields();
        }
      }
    }
  },
  mounted() {
    this.populateForm();
  },
  methods: {
    isEmpty,
    populateForm() {
      Object.assign(this.form, EMPTY_FORM);
      if (!isEmpty(this.user)) {
        const {
          first,
          last,
          username
        } = this.user;
        Object.assign(this.form, {
          first,
          last,
          username
        });
      }
    },
    callValidate() {
      this.$refs.userForm.validate(isValid => this.handleFormValidation(isValid));
    },
    handleFormValidation(isValid) {
      if (isValid) {
        this.$emit('valid', this.form);
      } else {
        this.$emit('invalid', this.form);
      }
    },
    nameValidator(field) {
      return (rule, val, cb) => {
        if (isUndefined(val) || val.trim().length === 0) {
          cb(`${field} cannot be blank.`);
        } else {
          cb();
        }
      };
    },
    validateUsername(rule, value, callback) {
      if (isEmpty(this.user) && this.findUserByUsername(value)) {
        callback(new Error('User already exists in this subscription. Please enter another email.'));
        return;
      }
      callback();
    },
    findUserByUsername(username) {
      if (username) {
        return this.userList.find(user => user.username.toLowerCase().trim() === username.toLowerCase().trim());
      }
    },
    updateHasAllRequiredFields() {
      const hasAll = Object.entries(this.rules).every(([fieldName, rules]) => {
        if (rules.find(({
          required
        }) => required)) {
          return !isEmpty(get(this.form, fieldName));
        }
        return true;
      });
      this.hasAllRequiredFields = hasAll;
      if (hasAll) {
        this.callValidate();
      }
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "user-details"
  }, [_c('pendo-form', {
    ref: "userForm",
    staticClass: "user-form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('pendo-form-item', {
    attrs: {
      "prop": "first",
      "label": "First Name",
      "data-cy": "first-name-input-group",
      "rules": _vm.rules.first
    }
  }, [!_vm.isEmpty(_vm.user) && _vm.isScimEnabled ? _c('span', [_vm._v(_vm._s(_vm.user.first))]) : _vm._e(), _vm._v(" "), !_vm.isScimEnabled ? _c('pendo-input', {
    staticClass: "user-details-input",
    attrs: {
      "autofocus": "",
      "placeholder": "First Name"
    },
    model: {
      value: _vm.form.first,
      callback: function ($$v) {
        _vm.$set(_vm.form, "first", $$v);
      },
      expression: "form.first"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('pendo-form-item', {
    attrs: {
      "prop": "last",
      "label": "Last Name",
      "data-cy": "last-name-input-group",
      "rules": _vm.rules.last
    }
  }, [!_vm.isEmpty(_vm.user) && _vm.isScimEnabled ? _c('span', [_vm._v(_vm._s(_vm.user.last))]) : _vm._e(), _vm._v(" "), !_vm.isScimEnabled ? _c('pendo-input', {
    staticClass: "user-details-input",
    attrs: {
      "placeholder": "Last Name"
    },
    model: {
      value: _vm.form.last,
      callback: function ($$v) {
        _vm.$set(_vm.form, "last", $$v);
      },
      expression: "form.last"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('pendo-form-item', {
    attrs: {
      "prop": "username",
      "label": "Email",
      "data-cy": "email-input-group",
      "rules": _vm.rules.username
    }
  }, [!_vm.isEmpty(_vm.user) ? _c('span', [_vm._v(_vm._s(_vm.user.username))]) : _c('pendo-input', {
    staticClass: "user-details-input",
    attrs: {
      "debounce": true,
      "placeholder": "Email"
    },
    model: {
      value: _vm.form.username,
      callback: function ($$v) {
        _vm.$set(_vm.form, "username", $$v);
      },
      expression: "form.username"
    }
  })], 1)], 1)], 1);
};
var __vue_staticRenderFns__$2 = [];

/* style */
const __vue_inject_styles__$2 = function (inject) {
  if (!inject) return;
  inject("data-v-cc9a385e_0", {
    source: ".user-details[data-v-cc9a385e]{display:flex}.user-form[data-v-cc9a385e]{flex:1;margin-top:24px}.user-details-input[data-v-cc9a385e]{max-width:250px}@media screen and (max-width:800px){.user-details[data-v-cc9a385e]{flex-direction:column}.user-form[data-v-cc9a385e]{margin-bottom:12px}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$2 = "data-v-cc9a385e";
/* module identifier */
const __vue_module_identifier__$2 = undefined;
/* functional template */
const __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
var script$1 = {
  name: 'EditUserOverlay',
  components: {
    PendoDrawer,
    PendoButton,
    PendoCard,
    PendoCardSection,
    FeedbackPermissionsGroup: __vue_component__$9,
    RoleTypeContainer: __vue_component__$3,
    UserDetails: __vue_component__$2
  },
  directives: {
    PendoTooltip,
    PendoNotification
  },
  props: {
    storybookMock: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    subId: {
      type: [Number, String],
      required: true
    },
    activeUser: {
      type: Object,
      required: true
    },
    selectedUser: {
      type: Object,
      default: () => ({})
    },
    productType: {
      type: String,
      required: true
    },
    roles: {
      type: Array,
      default: () => []
    },
    roleNameMap: {
      type: Object,
      default: () => ({})
    },
    apps: {
      type: Array,
      default: () => []
    },
    userList: {
      type: Array,
      required: true
    },
    isScimEnabled: {
      type: Boolean,
      default: false
    },
    subscriptionConfig: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      userDetails: {},
      applicationRoles: undefined,
      subscriptionRoles: [],
      updatingUser: false,
      roleSelected: false,
      frozenInitialUser: {},
      feedbackPermissionGroupId: undefined
    };
  },
  computed: {
    canDelete() {
      return !isEmpty(this.selectedUser);
    },
    confirmLabel() {
      if (isInvitation(this.selectedUser)) {
        return 'Save and Resend Invite';
      }
      if (!isEmpty(this.selectedUser)) {
        return 'Save Changes';
      }
      return this.subscriptionConfig.requireSSO ? 'Add User' : 'Invite User';
    },
    title() {
      if (!isEmpty(this.selectedUser)) {
        return 'Edit User';
      }
      return this.subscriptionConfig.requireSSO ? 'Add User' : 'Invite User';
    },
    canDeleteLabel() {
      return getRemovalStatement(this.selectedUser);
    },
    updatedUser() {
      const subRoles = this.subscriptionRoles.filter(role => role !== SUBSCRIPTION_USER_ROLE && role !== VOC_VIEWER_ROLE);
      const updatedUser = {
        ...this.selectedUser,
        ...this.userDetails,
        applicationRoles: this.sortAppRoles(this.applicationRoles),
        subscriptionRoles: this.sortSubRoles(subRoles)
      };
      if (this.isFeedbackUnifiedLoginEnabled) {
        updatedUser.vendorUserPermissionId = this.feedbackPermissionGroupId;
      }
      return updatedUser;
    },
    disableInviteUserButton() {
      if (this.applicationRoles) {
        const noRoles = Object.values(this.applicationRoles).every(app => app.length === 0);
        if (noRoles) {
          return true;
        }
      }
      const hasFeedBackUnifiedLoginError = this.isFeedbackUnifiedLoginEnabled && this.feedbackPermissionGroupId === undefined;
      if (hasFeedBackUnifiedLoginError) {
        return true;
      }
      if (isEmpty(this.selectedUser)) {
        return isEmpty(this.userDetails) || !this.roleSelected;
      }
      return isEqual(this.frozenInitialUser, this.updatedUser);
    },
    isFeedbackUnifiedLoginEnabled() {
      return !!this.subscriptionConfig.feedbackUnifiedLoginEnabled;
    },
    permissionGroups() {
      return values(this.subscriptionConfig.permissionGroupMap);
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (!isEmpty(this.selectedUser)) {
          this.configInitialUser(this.selectedUser);
          return;
        }
      }
    }
  },
  methods: {
    handleValidUserDetails(userFromForm) {
      if (this.visible) {
        this.$set(this, 'userDetails', userFromForm);
      }
    },
    handleInvalidUserDetails() {
      this.$set(this, 'userDetails', {});
    },
    handleValidFeedbackPermissions({
      permissionGroup
    }) {
      this.feedbackPermissionGroupId = permissionGroup.id;
    },
    handleInvalidFeedbackPermissions() {
      this.feedbackPermissionGroupId = undefined;
    },
    handleSubscriptionRoleTypeChange(subscriptionRoleIds) {
      this.$set(this, 'subscriptionRoles', subscriptionRoleIds);
    },
    handleAllApplicationPermissionChange(applicationPermissionsMap) {
      this.$set(this, 'applicationRoles', applicationPermissionsMap);
    },
    onClose(event) {
      this.$emit(event);
      this.frozenInitialUser = {};
      this.roleSelected = false;
      this.feedbackPermissionGroupId = undefined;
      this.$set(this, 'userDetails', {});
      this.$set(this, 'applicationRoles', undefined);
      this.$set(this, 'subscriptionRoles', []);
    },
    configInitialUser(user) {
      const subRoles = [];
      if (user.subscriptionRoles) {
        if (user.subscriptionRoles.includes(SUBSCRIPTION_ADMIN_ROLE)) {
          subRoles.push(SUBSCRIPTION_ADMIN_ROLE);
          if (isSuper(user)) {
            subRoles.push(SUPER_ROLE);
          }
          if (isOps(user)) {
            subRoles.push(OPS_ROLE);
          }
          if (isAdoptManager(user)) {
            subRoles.push(ADOPT_MANAGER_ROLE);
          }
        }
        user.subscriptionRoles.forEach(role => {
          if (!subRoles.includes(role)) {
            subRoles.push(role);
          }
        });
      }
      const initialUser = {
        ...user,
        subscriptionRoles: this.sortSubRoles(subRoles),
        applicationRoles: this.sortAppRoles(user.applicationRoles)
      };
      if (subRoles.includes(SUBSCRIPTION_ADMIN_ROLE)) {
        initialUser.applicationRoles = undefined;
      }
      this.frozenInitialUser = Object.freeze(cloneDeep(initialUser));
      return this.frozenInitialUser;
    },
    sortAppRoles(applicationRoles) {
      if (!isEmpty(applicationRoles)) {
        this.apps.forEach(app => {
          if (applicationRoles[app.id]) {
            applicationRoles[app.id].sort();
          }
        });
      }
      return applicationRoles;
    },
    sortSubRoles(subscriptionRoles) {
      if (subscriptionRoles) {
        return subscriptionRoles.sort();
      }
      return subscriptionRoles;
    },
    async invite(user) {
      if (this.storybookMock) {
        return;
      }
      const {
        username: email,
        first,
        last,
        applicationRoles = {},
        subscriptionRoles
      } = user;
      try {
        this.updatingUser = true;
        await createUser({
          subId: this.subId,
          user: {
            email,
            role: 2,
            first,
            last,
            applicationRoles,
            subscriptionRoles,
            ...(user.vendorUserPermissionId ? {
              permissiongroupid: user.vendorUserPermissionId
            } : {})
          }
        });
        PendoNotification({
          type: 'success',
          message: `${user.username} has been invited.`
        });
        this.$emit('user-invited');
      } catch (err) {
        if (err.response.status === 429) {
          PendoNotification({
            type: 'error',
            message: `${user.username} has already been invited. They will appear in the user list when they accept the invite.`
          });
        } else {
          PendoNotification({
            type: 'error',
            message: `Your request failed. Unable to invite ${user.username} at this time.\n${err}`
          });
        }
      }
      this.updatingUser = false;
    },
    async update(oldUser, updatedUser) {
      if (this.storybookMock) {
        this.$emit('user-updated', updatedUser);
        return;
      }
      this.updatingUser = true;
      updatedUser.id = oldUser.id;
      updatedUser.role = USER_ROLES.USER;
      const updateToAdmin = updatedUser.subscriptionRoles.includes(SUBSCRIPTION_ADMIN_ROLE);
      const updateToAdoptManager = updatedUser.subscriptionRoles.includes(ADOPT_MANAGER_ROLE);
      try {
        // if going from Admin with adoptManager to User, need to remove adoptManager flag first
        if (!updateToAdmin && (updateToAdoptManager || isAdoptManager(oldUser))) {
          await updateFlags({
            user: updatedUser,
            flags: {
              adoptManager: updateToAdoptManager
            },
            subId: this.subId
          });
        }
        if (updateToAdmin || isAdmin(oldUser)) {
          await updateFlags({
            user: updatedUser,
            flags: {
              admin: updateToAdmin
            },
            subId: this.subId
          });
        }

        // if going from User to Admin with adoptManager, need to make admin first
        if (updateToAdmin && (updateToAdoptManager || isAdoptManager(oldUser))) {
          await updateFlags({
            user: updatedUser,
            flags: {
              adoptManager: updateToAdoptManager
            },
            subId: this.subId
          });
        }
        if (updatedUser.subscriptionRoles.includes(SUPER_ROLE)) {
          updatedUser.role = USER_ROLES.SUPER;
        }
        await updateUser({
          subId: this.subId,
          user: {
            ...updatedUser,
            // remove roles that do not need to be passed to the API
            subscriptionRoles: updatedUser.subscriptionRoles.filter(isRoleManagedByAPI)
          }
        });
        if (updatedUser.subscriptionRoles.includes(OPS_ROLE) || isOps(oldUser)) {
          await updateFlags({
            user: updatedUser,
            flags: {
              opsFlag: updatedUser.subscriptionRoles.includes(OPS_ROLE)
            },
            subId: this.subId
          });
        }
        if (updatedUser.vendorUserPermissionId) {
          const updateTriggersForFeedback = user => pick(user, ['vendorUserPermissionId', 'first', 'last']);
          if (!isEqual(updateTriggersForFeedback(oldUser), updateTriggersForFeedback(updatedUser))) {
            await updateFeedbackVendorUserForUser({
              subId: this.subId,
              userId: updatedUser.id,
              ...updateTriggersForFeedback(updatedUser)
            });
          }
        }
        PendoNotification({
          type: 'success',
          message: `${updatedUser.username} has been successfully updated.`
        });
        this.$emit('user-updated', updatedUser);
      } catch (err) {
        PendoNotification({
          type: 'error',
          message: `Your request failed. Unable to update ${oldUser.username} at this time.\n${err}`
        });
      }
      this.updatingUser = false;
    },
    async handleConfirmation(user, updatedUser) {
      // Adopt doesn't have sharing permission configuration, so add the roles by default
      if (isAdoptSub(this.subscriptionConfig)) {
        updatedUser.subscriptionRoles.push(SHARE_SEGMENTS_ROLE, SHARE_REPORTS_ROLE);
      }
      if (isEmpty(user) || isInvitation(user)) {
        await this.invite(updatedUser);
      } else {
        await this.update(user, updatedUser);
      }
      this.onClose('closed');
    },
    showDeleteModal() {
      this.$emit('show-delete-modal', this.selectedUser);
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('pendo-drawer', {
    attrs: {
      "title": _vm.title,
      "size": "fullscreen",
      "visible": _vm.visible
    },
    on: {
      "close": function ($event) {
        return _vm.onClose('cancel');
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('transition', {
          attrs: {
            "name": "fade"
          }
        }, [_c('main', [_c('pendo-card', {
          staticClass: "card-container",
          attrs: {
            "data-cy": "user-overlay-card",
            "title": "User Permission Settings"
          },
          scopedSlots: _vm._u([{
            key: "body",
            fn: function () {
              return [_c('pendo-card-section', [_c('user-details', {
                staticClass: "card-section-content",
                attrs: {
                  "is-scim-enabled": _vm.isScimEnabled,
                  "user": _vm.selectedUser,
                  "user-list": _vm.userList
                },
                on: {
                  "valid": _vm.handleValidUserDetails,
                  "invalid": _vm.handleInvalidUserDetails
                }
              })], 1), _vm._v(" "), _c('pendo-card-section', [_c('div', [_c('p', {
                staticClass: "card-title"
              }, [_vm._v("\n                                    Assign " + _vm._s(_vm.productType) + " Access\n                                ")]), _vm._v(" "), _c('role-type-container', {
                staticClass: "role-type-card-section-content",
                attrs: {
                  "apps": _vm.apps,
                  "active-user": _vm.activeUser,
                  "product-type": _vm.productType,
                  "selected-user": _vm.selectedUser,
                  "roles": _vm.roles,
                  "role-name-map": _vm.roleNameMap,
                  "subscription-config": _vm.subscriptionConfig
                },
                on: {
                  "change-sub-level": _vm.handleSubscriptionRoleTypeChange,
                  "change-app-level": _vm.handleAllApplicationPermissionChange,
                  "role-selected": function ($event) {
                    _vm.roleSelected = true;
                  }
                }
              })], 1)]), _vm._v(" "), _vm.isFeedbackUnifiedLoginEnabled ? _c('pendo-card-section', [_c('p', {
                staticClass: "card-title"
              }, [_vm._v("\n                                Assign Feedback Access\n                            ")]), _vm._v(" "), _c('feedback-permissions-group', {
                staticClass: "feedback-card-section-content",
                attrs: {
                  "selected-user": _vm.selectedUser,
                  "permission-groups": _vm.permissionGroups
                },
                on: {
                  "valid": _vm.handleValidFeedbackPermissions,
                  "invalid": _vm.handleInvalidFeedbackPermissions
                }
              })], 1) : _vm._e()];
            },
            proxy: true
          }])
        })], 1)])];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_c('footer', {
          staticClass: "user-overlay-footer"
        }, [_vm.canDelete ? _c('pendo-button', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: _vm.isScimEnabled ? {
              content: 'Your users are managed via SCIM therefore<br/>deleting users is not available in Pendo.',
              arrow: true,
              html: true
            } : {},
            expression: "\n                    isScimEnabled\n                        ? {\n                            content:\n                                'Your users are managed via SCIM therefore<br/>deleting users is not available in Pendo.',\n                            arrow: true,\n                            html: true\n                        }\n                        : {}\n                "
          }],
          attrs: {
            "theme": "app",
            "type": "danger",
            "label": _vm.canDeleteLabel,
            "data-cy": "delete-modal-action",
            "disabled": _vm.updatingUser || _vm.isScimEnabled
          },
          on: {
            "click": _vm.showDeleteModal
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "user-overlay-footer--gap"
        }), _vm._v(" "), _c('pendo-button', {
          attrs: {
            "theme": "app",
            "type": "secondary",
            "label": "Cancel",
            "data-cy": "cancel-overlay-action",
            "disabled": _vm.updatingUser
          },
          on: {
            "click": function ($event) {
              return _vm.onClose('cancel');
            }
          }
        }), _vm._v(" "), _c('pendo-button', {
          attrs: {
            "disabled": _vm.disableInviteUserButton,
            "loading": _vm.updatingUser,
            "theme": "app",
            "type": "primary",
            "label": _vm.confirmLabel,
            "data-cy": "save-overlay-action"
          },
          on: {
            "click": function ($event) {
              return _vm.handleConfirmation(_vm.selectedUser, _vm.updatedUser);
            }
          }
        })], 1)];
      },
      proxy: true
    }])
  });
};
var __vue_staticRenderFns__$1 = [];

/* style */
const __vue_inject_styles__$1 = function (inject) {
  if (!inject) return;
  inject("data-v-eb688758_0", {
    source: ".card-title[data-v-eb688758]{user-select:text;text-transform:uppercase;color:#6a6c75;font-weight:700;font-size:12px;letter-spacing:.1em;margin:22px 24px}.card-section-content[data-v-eb688758]{margin:0 24px 12px 24px}.role-type-card-section-content[data-v-eb688758]{margin:0 24px 12px 24px}.card-container[data-v-eb688758]{margin:0 auto 2rem auto;max-width:800px;min-width:400px;width:70%}.feedback-card-section-content[data-v-eb688758]{margin:0 24px 24px}.user-overlay-footer[data-v-eb688758]{display:flex;grid-gap:8px}.user-overlay-footer .user-overlay-footer--gap[data-v-eb688758]{flex-grow:1}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$1 = "data-v-eb688758";
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

//
var script = {
  name: 'UserManagement',
  components: {
    DeleteUserModal: __vue_component__$a,
    EditUserOverlay: __vue_component__$1,
    UserSidePanel: __vue_component__$b,
    UsersTableView: __vue_component__$c
  },
  props: {
    activeUser: {
      type: Object,
      required: true
    },
    apps: {
      type: Array,
      required: true
    },
    isScimEnabled: {
      type: Boolean,
      default: false
    },
    loadingUsers: {
      type: Boolean,
      default: false
    },
    productLines: {
      type: Object,
      required: true
    },
    productType: {
      type: String,
      required: true
    },
    roles: {
      type: Array,
      default: () => []
    },
    roleNameMap: {
      type: Object,
      default: () => ({})
    },
    subscription: {
      type: Object,
      required: true
    },
    subscriptionConfig: {
      type: Object,
      default: () => ({})
    },
    userList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      deleteModal: {
        isVisible: false,
        user: {}
      },
      sidePanel: {
        isVisible: false,
        user: {}
      },
      userOverlay: {
        isVisible: false,
        user: {}
      }
    };
  },
  methods: {
    openSidePanel(user) {
      const v2RandP = this.subscriptionConfig.hasV2RolesAndPermissionsWithFeatureArea;
      if (!isUndefined(v2RandP) && !v2RandP) {
        this.openUserModal(user);
        return;
      }
      this.closeSidePanel();
      this.sidePanel.user = normalizeUserFields(user);
      this.sidePanel.isVisible = true;
    },
    closeSidePanel() {
      this.sidePanel.isVisible = false;
      this.sidePanel.user = {};
    },
    openUserModal(user) {
      this.closeSidePanel();
      this.userOverlay.user = normalizeUserFields(user);
      this.userOverlay.isVisible = true;
    },
    closeUserModal() {
      this.userOverlay.isVisible = false;
      this.userOverlay.user = {};
    },
    openDeleteModal(user) {
      this.deleteModal.user = user;
      this.deleteModal.isVisible = true;
    },
    onUserInvited() {
      this.$emit('invited-user');
    },
    onUserDeleted(user) {
      this.closeSidePanel();
      this.closeUserModal();
      this.$refs.usersTable.removeRow(user);
      this.$emit('deleted-user', user);
    },
    onUserUpdated(user) {
      this.$emit('update-user', user);
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "user-management"
  }, [_c('users-table-view', {
    ref: "usersTable",
    attrs: {
      "active-user": _vm.activeUser,
      "apps": _vm.apps,
      "is-loading": _vm.loadingUsers,
      "is-scim-enabled": _vm.isScimEnabled,
      "product-lines": _vm.productLines,
      "product-type": _vm.productType,
      "role-name-map": _vm.roleNameMap,
      "subscription": _vm.subscription,
      "subscription-config": _vm.subscriptionConfig,
      "user-list": _vm.userList
    },
    on: {
      "open-side-panel": _vm.openSidePanel,
      "open-user-modal": _vm.openUserModal,
      "show-delete-modal": _vm.openDeleteModal,
      "user-invited": _vm.onUserInvited,
      "load-permission-groups": function ($event) {
        return _vm.$emit('load-permission-groups');
      },
      "load-users": function ($event) {
        return _vm.$emit('load-users', $event);
      }
    }
  }), _vm._v(" "), _vm._t("userOverlay", function () {
    return [_c('edit-user-overlay', {
      attrs: {
        "visible": _vm.userOverlay.isVisible,
        "active-user": _vm.activeUser,
        "apps": _vm.apps,
        "is-scim-enabled": _vm.isScimEnabled,
        "roles": _vm.roles,
        "role-name-map": _vm.roleNameMap,
        "product-type": _vm.productType,
        "selected-user": _vm.userOverlay.user,
        "sub-id": _vm.subscription.id,
        "subscription-config": _vm.subscriptionConfig,
        "user-list": _vm.userList
      },
      on: {
        "user-invited": _vm.onUserInvited,
        "user-updated": _vm.onUserUpdated,
        "show-delete-modal": _vm.openDeleteModal,
        "cancel": _vm.closeUserModal,
        "closed": _vm.closeUserModal
      }
    })];
  }, {
    "visible": _vm.userOverlay.isVisible,
    "selectedUser": _vm.userOverlay.user,
    "showDeleteModal": _vm.openDeleteModal,
    "onUserInvited": _vm.onUserInvited,
    "onUserUpdated": _vm.onUserUpdated,
    "cancel": _vm.closeUserModal,
    "closed": _vm.closeUserModal
  }), _vm._v(" "), _c('user-side-panel', {
    attrs: {
      "visible": _vm.sidePanel.isVisible,
      "apps": _vm.apps,
      "can-select-viewer": _vm.subscriptionConfig.enableViewerPermission,
      "is-scim-enabled": _vm.isScimEnabled,
      "roles": _vm.roles,
      "role-name-map": _vm.roleNameMap,
      "show-sharing": _vm.subscriptionConfig.enableSharingPermission,
      "show-validate": _vm.subscriptionConfig.isVOC,
      "sub-id": _vm.subscription.id,
      "user": _vm.sidePanel.user
    },
    on: {
      "open-user-modal": _vm.openUserModal,
      "show-delete-modal": _vm.openDeleteModal,
      "closed": _vm.closeSidePanel
    }
  }), _vm._v(" "), _c('delete-user-modal', {
    attrs: {
      "visible": _vm.deleteModal.isVisible,
      "sub-id": _vm.subscription.id,
      "user": _vm.deleteModal.user
    },
    on: {
      "close": function ($event) {
        _vm.deleteModal.isVisible = false;
      },
      "closed": function ($event) {
        _vm.deleteModal.user = {};
      },
      "deleted": _vm.onUserDeleted
    }
  })], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function interceptRequest(config) {
  const configClone = cloneDeep(config);

  // we can remove this once adopt v2 migration is complete
  configClone.headers['x-adopt-v2'] = true;
  return configClone;
}

/* Set up config and hooks for using @pendo/http wrapper:
    import {http} from '@pendo/http';
    http.get('https://app.pendo.io/api/_SID_/user/_UID_');
*/

function initializeHttpWrapper() {
  initializeHttpWrapper$1({
    retryCount: 3,
    retryDelay: 500,
    interceptRequestExtensionHandler: interceptRequest,
    logout: () => false,
    getUserId: () => null,
    getSubscriptionId: () => null,
    getSubscriptionName: () => null
  });
}

/* eslint-disable padding-line-between-statements */
initializeHttpWrapper();

export { __vue_component__$e as AppRolesList, __vue_component__$a as DeleteUserModal, __vue_component__$1 as EditUserOverlay, __vue_component__$9 as FeedbackPermissionsGroup, __vue_component__$3 as RoleTypeContainer, __vue_component__ as UserManagement, __vue_component__$d as UserPermissionLevels, __vue_component__$b as UserSidePanel, __vue_component__$c as UsersTableView, index as Utils };
